export const DictionaryIllustrator_es_ES = [
    {
        id: 18,
        label: 'Edición > Pegar delante',
        placement: 'MenuBar',
        name: 'Pegar delante',
    },
    {
        id: 19,
        label: 'Edición > Pegar detrás',
        placement: 'MenuBar',
        name: 'Pegar detrás',
    },
    {
        id: 20,
        label: 'Archivo > Nuevo de plantilla...',
        placement: 'MenuBar',
        name: 'Nuevo de plantilla...',
    },
    {
        id: 22,
        label: 'Objeto > Transformar > Volver a transformar',
        placement: 'MenuBar',
        name: 'Volver a transformar',
    },
    {
        id: 23,
        label: 'Objeto > Agrupar',
        placement: 'MenuBar',
        name: 'Agrupar',
    },
    {
        id: 24,
        label: 'Objeto > Desagrupar',
        placement: 'MenuBar',
        name: 'Desagrupar',
    },
    {
        id: 25,
        label: 'Objeto > Trazado > Unir',
        placement: 'MenuBar',
        name: 'Unir',
    },
    {
        id: 26,
        label: 'Objeto > Trazado > Promediar...',
        placement: 'MenuBar',
        name: 'Promediar...',
    },
    {
        id: 28,
        label: 'Objeto > Bloquear > Selección',
        placement: 'MenuBar',
        name: 'Selección',
    },
    {
        id: 29,
        label: 'Objeto > Desbloquear todo',
        placement: 'MenuBar',
        name: 'Desbloquear todo',
    },
    {
        id: 30,
        label: 'Ver > Previsualizar',
        placement: 'MenuBar',
        name: 'Previsualizar',
    },
    {
        id: 33,
        label: 'Ver > Previsualización de píxeles',
        placement: 'MenuBar',
        name: 'Previsualización de píxeles',
    },
    {
        id: 34,
        label: 'Texto > Opciones de texto de área...',
        placement: 'MenuBar',
        name: 'Opciones de texto de área...',
    },
    {
        id: 35,
        label: 'Ver > Encajar mesa de trabajo en ventana',
        placement: 'MenuBar',
        name: 'Encajar mesa de trabajo en ventana',
    },
    {
        id: 36,
        label: 'Ventana > Nueva ventana',
        placement: 'MenuBar',
        name: 'Nueva ventana',
    },
    {
        id: 37,
        label: 'Ver > Reglas > Mostrar reglas',
        placement: 'MenuBar',
        name: 'Mostrar reglas',
    },
    {
        id: 38,
        label: 'Texto > Texto en trazado > Cinta 3D',
        placement: 'MenuBar',
        name: 'Cinta 3D',
    },
    {
        id: 40,
        label: 'Texto > Texto en trazado > Escalón',
        placement: 'MenuBar',
        name: 'Escalón',
    },
    {
        id: 42,
        label: 'Objeto > Organizar > Traer al frente',
        placement: 'MenuBar',
        name: 'Traer al frente',
    },
    {
        id: 43,
        label: 'Objeto > Organizar > Enviar detrás',
        placement: 'MenuBar',
        name: 'Enviar detrás',
    },
    {
        id: 48,
        label: 'Archivo > Guardar como plantilla...',
        placement: 'MenuBar',
        name: 'Guardar como plantilla...',
    },
    {
        id: 50,
        label: 'Objeto > Ocultar > Selección',
        placement: 'MenuBar',
        name: 'Selección',
    },
    {
        id: 51,
        label: 'Objeto > Mostrar todo',
        placement: 'MenuBar',
        name: 'Mostrar todo',
    },
    {
        id: 52,
        label: 'Ver > Guías > Crear guías',
        placement: 'MenuBar',
        name: 'Crear guías',
    },
    {
        id: 53,
        label: 'Ver > Guías > Soltar guías',
        placement: 'MenuBar',
        name: 'Soltar guías',
    },
    {
        id: 54,
        label: 'Objeto > Transformar > Mover...',
        placement: 'MenuBar',
        name: 'Mover...',
    },
    {
        id: 55,
        label: 'Illustrator > Preferencias > Guías inteligentes...',
        placement: 'MenuBar',
        name: 'Guías inteligentes...',
    },
    {
        id: 56,
        label: 'Objeto > Trazado compuesto > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 57,
        label: 'Objeto > Trazado compuesto > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 62,
        label: 'Texto > Crear contornos',
        placement: 'MenuBar',
        name: 'Crear contornos',
    },
    {
        id: 63,
        label: 'Ver > Tamaño real',
        placement: 'MenuBar',
        name: 'Tamaño real',
    },
    {
        id: 74,
        label: 'Objeto > Gráfica > Tipo...',
        placement: 'MenuBar',
        name: 'Tipo...',
    },
    {
        id: 75,
        label: 'Objeto > Gráfica > Datos...',
        placement: 'MenuBar',
        name: 'Datos...',
    },
    {
        id: 76,
        label: 'Objeto > Gráfica > Columna...',
        placement: 'MenuBar',
        name: 'Columna...',
    },
    {
        id: 77,
        label: 'Objeto > Gráfica > Diseño...',
        placement: 'MenuBar',
        name: 'Diseño...',
    },
    {
        id: 78,
        label: 'Objeto > Gráfica > Marcador...',
        placement: 'MenuBar',
        name: 'Marcador...',
    },
    {
        id: 83,
        label: 'Texto > Texto en trazado > Arco iris',
        placement: 'MenuBar',
        name: 'Arco iris',
    },
    {
        id: 84,
        label: 'Archivo > Ajustar documento...',
        placement: 'MenuBar',
        name: 'Ajustar documento...',
    },
    {
        id: 85,
        label: 'Ver > Ocultar segmentación de impresión',
        placement: 'MenuBar',
        name: 'Ocultar segmentación de impresión',
    },
    {
        id: 86,
        label: 'Ver > Ocultar mesas de trabajo',
        placement: 'MenuBar',
        name: 'Ocultar mesas de trabajo',
    },
    {
        id: 87,
        label: 'Texto > Encajar titular',
        placement: 'MenuBar',
        name: 'Encajar titular',
    },
    {
        id: 95,
        label: 'Archivo > Guardar una copia...',
        placement: 'MenuBar',
        name: 'Guardar una copia...',
    },
    {
        id: 98,
        label: 'Illustrator > Preferencias > Texto...',
        placement: 'MenuBar',
        name: 'Texto...',
    },
    {
        id: 99,
        label: 'Illustrator > Preferencias > Unidades...',
        placement: 'MenuBar',
        name: 'Unidades...',
    },
    {
        id: 100,
        label: 'Objeto > Organizar > Hacia delante',
        placement: 'MenuBar',
        name: 'Hacia delante',
    },
    {
        id: 101,
        label: 'Objeto > Organizar > Hacia atrás',
        placement: 'MenuBar',
        name: 'Hacia atrás',
    },
    {
        id: 109,
        label: 'Ventana > Organizar > Minimizar ventana',
        placement: 'MenuBar',
        name: 'Minimizar ventana',
    },
    {
        id: 110,
        label: 'Ventana > Organizar > Traer todo al frente',
        placement: 'MenuBar',
        name: 'Traer todo al frente',
    },
    {
        id: 113,
        label: 'Ver > Guías > Borrar guías',
        placement: 'MenuBar',
        name: 'Borrar guías',
    },
    {
        id: 114,
        label: 'Ver > Mostrar plantilla',
        placement: 'MenuBar',
        name: 'Mostrar plantilla',
    },
    {
        id: 115,
        label: 'Texto > Mostrar caracteres ocultos',
        placement: 'MenuBar',
        name: 'Mostrar caracteres ocultos',
    },
    {
        id: 116,
        label: 'Texto > Texto en trazado > Sesgar',
        placement: 'MenuBar',
        name: 'Sesgar',
    },
    {
        id: 117,
        label: 'Archivo > Cerrar todo',
        placement: 'MenuBar',
        name: 'Cerrar todo',
    },
    {
        id: 119,
        label: 'Texto > Texto en trazado > Gravedad',
        placement: 'MenuBar',
        name: 'Gravedad',
    },
    {
        id: 120,
        label: 'Objeto > Máscara de recorte > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 121,
        label: 'Objeto > Máscara de recorte > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 123,
        label: 'Texto > Texto en trazado > Opciones de texto en trazado...',
        placement: 'MenuBar',
        name: 'Opciones de texto en trazado...',
    },
    {
        id: 127,
        label: 'Objeto > Mesas de trabajo > Convertir a mesas de trabajo',
        placement: 'MenuBar',
        name: 'Convertir a mesas de trabajo',
    },
    {
        id: 133,
        label: 'Texto > Texto enlazado > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 135,
        label: 'Ver > Aumentar',
        placement: 'MenuBar',
        name: 'Aumentar',
    },
    {
        id: 136,
        label: 'Ver > Reducir',
        placement: 'MenuBar',
        name: 'Reducir',
    },
    {
        id: 139,
        label: 'Edición > Ajustes de color...',
        placement: 'MenuBar',
        name: 'Ajustes de color...',
    },
    {
        id: 140,
        label: 'Illustrator > Preferencias > Separación de sílabas...',
        placement: 'MenuBar',
        name: 'Separación de sílabas...',
    },
    {
        id: 141,
        label: 'Illustrator > Preferencias > Plugins y memoria virtual...',
        placement: 'MenuBar',
        name: 'Plugins y memoria virtual...',
    },
    {
        id: 142,
        label: 'Seleccionar > Deseleccionar',
        placement: 'MenuBar',
        name: 'Deseleccionar',
    },
    {
        id: 143,
        label: 'Ver > Previsualizar sobreimpresión',
        placement: 'MenuBar',
        name: 'Previsualizar sobreimpresión',
    },
    {
        id: 144,
        label: 'Ver > Nueva vista...',
        placement: 'MenuBar',
        name: 'Nueva vista...',
    },
    {
        id: 145,
        label: 'Ver > Editar vistas...',
        placement: 'MenuBar',
        name: 'Editar vistas...',
    },
    {
        id: 146,
        label: 'Ver > Ajustar al punto',
        placement: 'MenuBar',
        name: 'Ajustar al punto',
    },
    {
        id: 147,
        label: 'Ver > Ocultar bordes',
        placement: 'MenuBar',
        name: 'Ocultar bordes',
    },
    {
        id: 148,
        label: 'Objeto > Expandir apariencia',
        placement: 'MenuBar',
        name: 'Expandir apariencia',
    },
    {
        id: 150,
        label: 'Ver > Mostrar enlaces de texto',
        placement: 'MenuBar',
        name: 'Mostrar enlaces de texto',
    },
    {
        id: 154,
        label: 'Ver > Guías > Ocultar guías',
        placement: 'MenuBar',
        name: 'Ocultar guías',
    },
    {
        id: 155,
        label: 'Ver > Guías > Bloquear guías',
        placement: 'MenuBar',
        name: 'Bloquear guías',
    },
    {
        id: 157,
        label: 'Texto > Texto enlazado > Soltar selección',
        placement: 'MenuBar',
        name: 'Soltar selección',
    },
    {
        id: 158,
        label: 'Texto > Texto enlazado > Quitar enlace',
        placement: 'MenuBar',
        name: 'Quitar enlace',
    },
    {
        id: 159,
        label: 'Ver > Mostrar cuadrícula',
        placement: 'MenuBar',
        name: 'Mostrar cuadrícula',
    },
    {
        id: 160,
        label: 'Ver > Ajustar a cuadrícula',
        placement: 'MenuBar',
        name: 'Ajustar a cuadrícula',
    },
    {
        id: 161,
        label: 'Illustrator > Preferencias > Guías y cuadrícula...',
        placement: 'MenuBar',
        name: 'Guías y cuadrícula...',
    },
    {
        id: 162,
        label: 'Objeto > Transformar > Rotar...',
        placement: 'MenuBar',
        name: 'Rotar...',
    },
    {
        id: 163,
        label: 'Objeto > Transformar > Escala...',
        placement: 'MenuBar',
        name: 'Escala...',
    },
    {
        id: 164,
        label: 'Objeto > Transformar > Reflejo...',
        placement: 'MenuBar',
        name: 'Reflejo...',
    },
    {
        id: 165,
        label: 'Objeto > Transformar > Distorsionar...',
        placement: 'MenuBar',
        name: 'Distorsionar...',
    },
    {
        id: 166,
        label: 'Ventana > Organizar > Cascada',
        placement: 'MenuBar',
        name: 'Cascada',
    },
    {
        id: 168,
        label: 'Ventana > Organizar > Mosaico',
        placement: 'MenuBar',
        name: 'Mosaico',
    },
    {
        id: 202,
        label: 'Ver > Colores de prueba',
        placement: 'MenuBar',
        name: 'Colores de prueba',
    },
    {
        id: 203,
        label: 'Edición > Asignar perfil...',
        placement: 'MenuBar',
        name: 'Asignar perfil...',
    },
    {
        id: 204,
        label: 'Ayuda > Tutoriales...',
        placement: 'MenuBar',
        name: 'Tutoriales...',
    },
    {
        id: 223,
        label: 'Archivo > Modo de color del documento > Color CMYK',
        placement: 'MenuBar',
        name: 'Color CMYK',
    },
    {
        id: 224,
        label: 'Archivo > Modo de color del documento > Color RGB',
        placement: 'MenuBar',
        name: 'Color RGB',
    },
    {
        id: 225,
        label: 'Ver > Ajuste de prueba > CMYK de documento:',
        placement: 'MenuBar',
        name: 'CMYK de documento:',
    },
    {
        id: 226,
        label: 'Ver > Ajuste de prueba > RGB de Macintosh heredado (Gamma 1.8)',
        placement: 'MenuBar',
        name: 'RGB de Macintosh heredado (Gamma 1.8)',
    },
    {
        id: 227,
        label: 'Ver > Ajuste de prueba > RGB estándar para Internet (sRGB)',
        placement: 'MenuBar',
        name: 'RGB estándar para Internet (sRGB)',
    },
    {
        id: 228,
        label: 'Ver > Ajuste de prueba > RGB Monitor',
        placement: 'MenuBar',
        name: 'RGB Monitor',
    },
    {
        id: 229,
        label: 'Texto > Orientación del texto > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 230,
        label: 'Texto > Orientación del texto > Vertical',
        placement: 'MenuBar',
        name: 'Vertical',
    },
    {
        id: 232,
        label: 'Ayuda > Información del sistema...',
        placement: 'MenuBar',
        name: 'Información del sistema...',
    },
    {
        id: 278,
        label: 'Texto > Texto heredado > Actualizar todo el texto heredado',
        placement: 'MenuBar',
        name: 'Actualizar todo el texto heredado',
    },
    {
        id: 279,
        label: 'Texto > Texto heredado > Actualizar el texto heredado seleccionado',
        placement: 'MenuBar',
        name: 'Actualizar el texto heredado seleccionado',
    },
    {
        id: 280,
        label: 'Texto > Texto heredado > Ocultar copias',
        placement: 'MenuBar',
        name: 'Ocultar copias',
    },
    {
        id: 281,
        label: 'Texto > Texto heredado > Eliminar copias',
        placement: 'MenuBar',
        name: 'Eliminar copias',
    },
    {
        id: 282,
        label: 'Texto > Texto heredado > Seleccionar copias',
        placement: 'MenuBar',
        name: 'Seleccionar copias',
    },
    {
        id: 284,
        label: 'Ver > Ajuste de prueba > Personalizar...',
        placement: 'MenuBar',
        name: 'Personalizar...',
    },
    {
        id: 289,
        label: 'Illustrator > Preferencias > Selección y visualización de puntos de ancla...',
        placement: 'MenuBar',
        name: 'Selección y visualización de puntos de ancla...',
    },
    {
        id: 292,
        label: 'Objeto > Máscara de recorte > Editar contenido',
        placement: 'MenuBar',
        name: 'Editar contenido',
    },
    {
        id: 293,
        label: 'Illustrator > Preferencias > Interfaz de usuario',
        placement: 'MenuBar',
        name: 'Interfaz de usuario',
    },
    {
        id: 294,
        label: 'Illustrator > Preferencias > Sectores...',
        placement: 'MenuBar',
        name: 'Sectores...',
    },
    {
        id: 295,
        label: 'Ventana > Cuadro de aplicación',
        placement: 'MenuBar',
        name: 'Cuadro de aplicación',
    },
    {
        id: 296,
        label: 'Ver > Ajuste de prueba > Ceguera de los colores - Protanopia',
        placement: 'MenuBar',
        name: 'Ceguera de los colores - Protanopia',
    },
    {
        id: 297,
        label: 'Ver > Ajuste de prueba > Ceguera de los colores - Deuteranopia',
        placement: 'MenuBar',
        name: 'Ceguera de los colores - Deuteranopia',
    },
    {
        id: 299,
        label: 'Ver > Reglas > Mostrar reglas de vídeo',
        placement: 'MenuBar',
        name: 'Mostrar reglas de vídeo',
    },
    {
        id: 301,
        label: 'Ventana > Organizar > Flotante en ventana',
        placement: 'MenuBar',
        name: 'Flotante en ventana',
    },
    {
        id: 302,
        label: 'Ventana > Organizar > Todo flotante en ventanas',
        placement: 'MenuBar',
        name: 'Todo flotante en ventanas',
    },
    {
        id: 303,
        label: 'Ventana > Organizar > Consolidar todas las ventanas',
        placement: 'MenuBar',
        name: 'Consolidar todas las ventanas',
    },
    {
        id: 304,
        label: 'Ventana > Barra de aplicación',
        placement: 'MenuBar',
        name: 'Barra de aplicación',
    },
    {
        id: 310,
        label: 'Texto > Texto en trazado > Actualizar texto heredado en trazado',
        placement: 'MenuBar',
        name: 'Actualizar texto heredado en trazado',
    },
    {
        id: 311,
        label: 'Ver > Encajar todo en ventana',
        placement: 'MenuBar',
        name: 'Encajar todo en ventana',
    },
    {
        id: 315,
        label: 'Edición > Pegar en el mismo lugar',
        placement: 'MenuBar',
        name: 'Pegar en el mismo lugar',
    },
    {
        id: 316,
        label: 'Edición > Pegar en todas las mesas de trabajo',
        placement: 'MenuBar',
        name: 'Pegar en todas las mesas de trabajo',
    },
    {
        id: 331,
        label: 'Texto > Conversión a texto',
        placement: 'MenuBar',
        name: 'Conversión a texto',
    },
    {
        id: 339,
        label: 'Edición > Mi configuración > Exportar configuración...',
        placement: 'MenuBar',
        name: 'Exportar configuración...',
    },
    {
        id: 340,
        label: 'Edición > Mi configuración > Importar configuración...',
        placement: 'MenuBar',
        name: 'Importar configuración...',
    },
    {
        id: 347,
        label: 'Ver > Ver GPU en uso',
        placement: 'MenuBar',
        name: 'Ver GPU en uso',
    },
    {
        id: 351,
        label: 'Archivo > Exportar selección...',
        placement: 'MenuBar',
        name: 'Exportar selección...',
    },
    {
        id: 353,
        label: 'Ver > Ajustar al píxel',
        placement: 'MenuBar',
        name: 'Ajustar al píxel',
    },
    {
        id: 354,
        label: 'Archivo > Exportar > Exportar para pantallas...',
        placement: 'MenuBar',
        name: 'Exportar para pantallas...',
    },
    {
        id: 355,
        label: 'Archivo > Exportar > Exportar como...',
        placement: 'MenuBar',
        name: 'Exportar como...',
    },
    {
        id: 356,
        label: 'Archivo > Exportar > Guardar para Web (heredado)...',
        placement: 'MenuBar',
        name: 'Guardar para Web (heredado)...',
    },
    {
        id: 368,
        label: 'Texto > Insertar carácter especial > Símbolos > Viñeta',
        placement: 'MenuBar',
        name: 'Viñeta',
    },
    {
        id: 369,
        label: 'Texto > Insertar carácter especial > Símbolos > Símbolo de copyright',
        placement: 'MenuBar',
        name: 'Símbolo de copyright',
    },
    {
        id: 370,
        label: 'Texto > Insertar carácter especial > Símbolos > Puntos suspensivos',
        placement: 'MenuBar',
        name: 'Puntos suspensivos',
    },
    {
        id: 371,
        label: 'Texto > Insertar carácter especial > Símbolos > Símbolo de párrafo',
        placement: 'MenuBar',
        name: 'Símbolo de párrafo',
    },
    {
        id: 372,
        label: 'Texto > Insertar carácter especial > Símbolos > Símbolo de marca comercial registrada',
        placement: 'MenuBar',
        name: 'Símbolo de marca comercial registrada',
    },
    {
        id: 373,
        label: 'Texto > Insertar carácter especial > Símbolos > Símbolo de sección',
        placement: 'MenuBar',
        name: 'Símbolo de sección',
    },
    {
        id: 374,
        label: 'Texto > Insertar carácter especial > Símbolos > Símbolo de marca comercial',
        placement: 'MenuBar',
        name: 'Símbolo de marca comercial',
    },
    {
        id: 375,
        label: 'Texto > Insertar carácter especial > Comillas > Comillas de apertura',
        placement: 'MenuBar',
        name: 'Comillas de apertura',
    },
    {
        id: 376,
        label: 'Texto > Insertar carácter especial > Comillas > Comillas de cierre',
        placement: 'MenuBar',
        name: 'Comillas de cierre',
    },
    {
        id: 377,
        label: 'Texto > Insertar carácter especial > Comillas > Comillas de apertura simples',
        placement: 'MenuBar',
        name: 'Comillas de apertura simples',
    },
    {
        id: 378,
        label: 'Texto > Insertar carácter especial > Comillas > Comillas de cierre simples',
        placement: 'MenuBar',
        name: 'Comillas de cierre simples',
    },
    {
        id: 379,
        label: 'Texto > Insertar carácter especial > Guiones y rayas > Guion largo',
        placement: 'MenuBar',
        name: 'Guion largo',
    },
    {
        id: 380,
        label: 'Texto > Insertar carácter especial > Guiones y rayas > Guion corto',
        placement: 'MenuBar',
        name: 'Guion corto',
    },
    {
        id: 381,
        label: 'Texto > Insertar carácter especial > Guiones y rayas > Guion discrecional',
        placement: 'MenuBar',
        name: 'Guion discrecional',
    },
    {
        id: 382,
        label: 'Texto > Insertar carácter de espacio en blanco > Espacio largo',
        placement: 'MenuBar',
        name: 'Espacio largo',
    },
    {
        id: 383,
        label: 'Texto > Insertar carácter de espacio en blanco > Espacio corto',
        placement: 'MenuBar',
        name: 'Espacio corto',
    },
    {
        id: 384,
        label: 'Texto > Insertar carácter de espacio en blanco > Espacio ultrafino',
        placement: 'MenuBar',
        name: 'Espacio ultrafino',
    },
    {
        id: 385,
        label: 'Texto > Insertar carácter de espacio en blanco > Espacio fino',
        placement: 'MenuBar',
        name: 'Espacio fino',
    },
    {
        id: 386,
        label: 'Texto > Insertar carácter de rotura > Salto de línea forzado',
        placement: 'MenuBar',
        name: 'Salto de línea forzado',
    },
    {
        id: 391,
        label: 'Texto > Rellenar con texto falso',
        placement: 'MenuBar',
        name: 'Rellenar con texto falso',
    },
    {
        id: 393,
        label: 'Objeto > Recopilar para exportar > Como recurso único',
        placement: 'MenuBar',
        name: 'Como recurso único',
    },
    {
        id: 394,
        label: 'Objeto > Recopilar para exportar > Como varios recursos',
        placement: 'MenuBar',
        name: 'Como varios recursos',
    },
    {
        id: 396,
        label: 'Ver > Vista de recorte',
        placement: 'MenuBar',
        name: 'Vista de recorte',
    },
    {
        id: 397,
        label: 'Ver > Modo Presentación',
        placement: 'MenuBar',
        name: 'Modo Presentación',
    },
    {
        id: 404,
        label: 'Ver > Modo de pantalla > Modo de pantalla normal',
        placement: 'MenuBar',
        name: 'Modo de pantalla normal',
    },
    {
        id: 405,
        label: 'Ver > Modo de pantalla > Modo de pantalla completa con barra de menús',
        placement: 'MenuBar',
        name: 'Modo de pantalla completa con barra de menús',
    },
    {
        id: 406,
        label: 'Ver > Modo de pantalla > Modo de pantalla completa',
        placement: 'MenuBar',
        name: 'Modo de pantalla completa',
    },
    {
        id: 411,
        label: 'Ver > Ajustar a pictograma',
        placement: 'MenuBar',
        name: 'Ajustar a pictograma',
    },
    {
        id: 415,
        label: 'Ver > Rotar vista en selección',
        placement: 'MenuBar',
        name: 'Rotar vista en selección',
    },
    {
        id: 417,
        label: 'Ver > Rotar vista > 180',
        placement: 'MenuBar',
        name: '180',
    },
    {
        id: 418,
        label: 'Ver > Rotar vista > 150',
        placement: 'MenuBar',
        name: '150',
    },
    {
        id: 419,
        label: 'Ver > Rotar vista > 135',
        placement: 'MenuBar',
        name: '135',
    },
    {
        id: 420,
        label: 'Ver > Rotar vista > 120',
        placement: 'MenuBar',
        name: '120',
    },
    {
        id: 421,
        label: 'Ver > Rotar vista > 90',
        placement: 'MenuBar',
        name: '90',
    },
    {
        id: 422,
        label: 'Ver > Rotar vista > 60',
        placement: 'MenuBar',
        name: '60',
    },
    {
        id: 423,
        label: 'Ver > Rotar vista > 45',
        placement: 'MenuBar',
        name: '45',
    },
    {
        id: 424,
        label: 'Ver > Rotar vista > 30',
        placement: 'MenuBar',
        name: '30',
    },
    {
        id: 425,
        label: 'Ver > Rotar vista > 15',
        placement: 'MenuBar',
        name: '15',
    },
    {
        id: 426,
        label: 'Ver > Rotar vista > 0',
        placement: 'MenuBar',
        name: '0',
    },
    {
        id: 427,
        label: 'Ver > Rotar vista > -15',
        placement: 'MenuBar',
        name: '-15',
    },
    {
        id: 428,
        label: 'Ver > Rotar vista > -30',
        placement: 'MenuBar',
        name: '-30',
    },
    {
        id: 429,
        label: 'Ver > Rotar vista > -45',
        placement: 'MenuBar',
        name: '-45',
    },
    {
        id: 430,
        label: 'Ver > Rotar vista > -60',
        placement: 'MenuBar',
        name: '-60',
    },
    {
        id: 431,
        label: 'Ver > Rotar vista > -90',
        placement: 'MenuBar',
        name: '-90',
    },
    {
        id: 432,
        label: 'Ver > Rotar vista > -120',
        placement: 'MenuBar',
        name: '-120',
    },
    {
        id: 433,
        label: 'Ver > Rotar vista > -135',
        placement: 'MenuBar',
        name: '-135',
    },
    {
        id: 434,
        label: 'Ver > Rotar vista > -150',
        placement: 'MenuBar',
        name: '-150',
    },
    {
        id: 435,
        label: 'Ver > Rotar vista > -180',
        placement: 'MenuBar',
        name: '-180',
    },
    {
        id: 436,
        label: 'Ver > Restablecer Rotar vista',
        placement: 'MenuBar',
        name: 'Restablecer Rotar vista',
    },
    {
        id: 437,
        label: 'Edición > Pegar sin formato',
        placement: 'MenuBar',
        name: 'Pegar sin formato',
    },
    {
        id: 438,
        label: 'Ayuda > Novedades...',
        placement: 'MenuBar',
        name: 'Novedades...',
    },
    {
        id: 440,
        label: 'Texto > Viñetas y numeración > Aplicar viñetas',
        placement: 'MenuBar',
        name: 'Aplicar viñetas',
    },
    {
        id: 441,
        label: 'Texto > Viñetas y numeración > Aplicar números',
        placement: 'MenuBar',
        name: 'Aplicar números',
    },
    {
        id: 448,
        label: 'Texto > Viñetas y numeración > Convertir a texto',
        placement: 'MenuBar',
        name: 'Convertir a texto',
    },
    {
        id: 456,
        label: 'Texto > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 471,
        label: 'Objeto > Desagrupar todo',
        placement: 'MenuBar',
        name: 'Desagrupar todo',
    },
    {
        id: 472,
        label: 'Texto > Insertar carácter de espacio en blanco > Espacio de no separación',
        placement: 'MenuBar',
        name: 'Espacio de no separación',
    },
    {
        id: 1383427079,
        label: 'Ver > Reglas > Cambiar a reglas de la mesa de trabajo',
        placement: 'MenuBar',
        name: 'Cambiar a reglas de la mesa de trabajo',
    },
    {
        id: 1633841013,
        label: 'Illustrator > Acerca de Illustrator...',
        placement: 'MenuBar',
        name: 'Acerca de Illustrator...',
    },
    {
        id: 1634233456,
        label: 'Ayuda > Ayuda de Illustrator...',
        placement: 'MenuBar',
        name: 'Ayuda de Illustrator...',
    },
    {
        id: 1634296684,
        label: 'Archivo > Cerrar',
        placement: 'MenuBar',
        name: 'Cerrar',
    },
    {
        id: 1668048225,
        label: 'Edición > Borrar',
        placement: 'MenuBar',
        name: 'Borrar',
    },
    {
        id: 1668247673,
        label: 'Edición > Copiar',
        placement: 'MenuBar',
        name: 'Copiar',
    },
    {
        id: 1668641824,
        label: 'Edición > Cortar',
        placement: 'MenuBar',
        name: 'Cortar',
    },
    {
        id: 1751737445,
        label: 'Illustrator > Ocultar Illustrator',
        placement: 'MenuBar',
        name: 'Ocultar Illustrator',
    },
    {
        id: 1751737455,
        label: 'Illustrator > Ocultar otras',
        placement: 'MenuBar',
        name: 'Ocultar otras',
    },
    {
        id: 1852143392,
        label: 'Archivo > Nuevo...',
        placement: 'MenuBar',
        name: 'Nuevo...',
    },
    {
        id: 1869636974,
        label: 'Archivo > Abrir...',
        placement: 'MenuBar',
        name: 'Abrir...',
    },
    {
        id: 1885434740,
        label: 'Edición > Pegar',
        placement: 'MenuBar',
        name: 'Pegar',
    },
    {
        id: 1886545254,
        label: 'Illustrator > Preferencias > Generales...',
        placement: 'MenuBar',
        name: 'Generales...',
    },
    {
        id: 1903520116,
        label: 'Illustrator > Salir de Illustrator',
        placement: 'MenuBar',
        name: 'Salir de Illustrator',
    },
    {
        id: 1919247471,
        label: 'Edición > Rehacer',
        placement: 'MenuBar',
        name: 'Rehacer',
    },
    {
        id: 1920365172,
        label: 'Archivo > Volver',
        placement: 'MenuBar',
        name: 'Volver',
    },
    {
        id: 1934727834,
        label: 'Seleccionar > Todo en la mesa de trabajo activa',
        placement: 'MenuBar',
        name: 'Todo en la mesa de trabajo activa',
    },
    {
        id: 1935764588,
        label: 'Seleccionar > Todo',
        placement: 'MenuBar',
        name: 'Todo',
    },
    {
        id: 1935767141,
        label: 'Archivo > Guardar',
        placement: 'MenuBar',
        name: 'Guardar',
    },
    {
        id: 1936220524,
        label: 'Illustrator > Mostrar todo',
        placement: 'MenuBar',
        name: 'Mostrar todo',
    },
    {
        id: 1936292352,
        label: 'Texto > Tamaño > 6 pt',
        placement: 'MenuBar',
        name: '6 pt',
    },
    {
        id: 1936292353,
        label: 'Texto > Tamaño > 7 pt',
        placement: 'MenuBar',
        name: '7 pt',
    },
    {
        id: 1936292354,
        label: 'Texto > Tamaño > 8 pt',
        placement: 'MenuBar',
        name: '8 pt',
    },
    {
        id: 1936292355,
        label: 'Texto > Tamaño > 9 pt',
        placement: 'MenuBar',
        name: '9 pt',
    },
    {
        id: 1936292356,
        label: 'Texto > Tamaño > 10 pt',
        placement: 'MenuBar',
        name: '10 pt',
    },
    {
        id: 1936292357,
        label: 'Texto > Tamaño > 11 pt',
        placement: 'MenuBar',
        name: '11 pt',
    },
    {
        id: 1936292358,
        label: 'Texto > Tamaño > 12 pt',
        placement: 'MenuBar',
        name: '12 pt',
    },
    {
        id: 1936292359,
        label: 'Texto > Tamaño > 14 pt',
        placement: 'MenuBar',
        name: '14 pt',
    },
    {
        id: 1936292360,
        label: 'Texto > Tamaño > 18 pt',
        placement: 'MenuBar',
        name: '18 pt',
    },
    {
        id: 1936292361,
        label: 'Texto > Tamaño > 21 pt',
        placement: 'MenuBar',
        name: '21 pt',
    },
    {
        id: 1936292362,
        label: 'Texto > Tamaño > 24 pt',
        placement: 'MenuBar',
        name: '24 pt',
    },
    {
        id: 1936292363,
        label: 'Texto > Tamaño > 36 pt',
        placement: 'MenuBar',
        name: '36 pt',
    },
    {
        id: 1936292364,
        label: 'Texto > Tamaño > 48 pt',
        placement: 'MenuBar',
        name: '48 pt',
    },
    {
        id: 1936292365,
        label: 'Texto > Tamaño > 60 pt',
        placement: 'MenuBar',
        name: '60 pt',
    },
    {
        id: 1936292366,
        label: 'Texto > Tamaño > 72 pt',
        placement: 'MenuBar',
        name: '72 pt',
    },
    {
        id: 1936292367,
        label: 'Texto > Tamaño > Otro...',
        placement: 'MenuBar',
        name: 'Otro...',
    },
    {
        id: 1937138035,
        label: 'Archivo > Guardar como...',
        placement: 'MenuBar',
        name: 'Guardar como...',
    },
    {
        id: 1970168943,
        label: 'Edición > Deshacer',
        placement: 'MenuBar',
        name: 'Deshacer',
    },
    {
        id: 2164260867,
        label: 'Ayuda > Administrar mi cuenta...',
        placement: 'MenuBar',
        name: 'Administrar mi cuenta...',
    },
    {
        id: 2164260869,
        label: 'Ayuda > Actualizaciones...',
        placement: 'MenuBar',
        name: 'Actualizaciones...',
    },
    {
        id: 2164260870,
        label: 'Efecto > Aplicar último efecto',
        placement: 'MenuBar',
        name: 'Aplicar último efecto',
    },
    {
        id: 2164260871,
        label: 'Efecto > Último efecto',
        placement: 'MenuBar',
        name: 'Último efecto',
    },
    {
        id: 2164260872,
        label: 'Archivo > Buscar Adobe Stock...',
        placement: 'MenuBar',
        name: 'Buscar Adobe Stock...',
    },
    {
        id: 2164260873,
        label: 'Archivo > Colocar...',
        placement: 'MenuBar',
        name: 'Colocar...',
    },
    {
        id: 2164260874,
        label: 'Objeto > Trazado > Quitar puntos de ancla',
        placement: 'MenuBar',
        name: 'Quitar puntos de ancla',
    },
    {
        id: 2164260877,
        label: 'Ayuda > Debug > Memory Use Checkpoint',
        placement: 'MenuBar',
        name: 'Memory Use Checkpoint',
    },
    {
        id: 2164260878,
        label: 'Ayuda > Debug > Save Memory Use',
        placement: 'MenuBar',
        name: 'Save Memory Use',
    },
    {
        id: 2164260880,
        label: 'Ayuda > Debug > Progress: Bar Shown',
        placement: 'MenuBar',
        name: 'Progress: Bar Shown',
    },
    {
        id: 2164260881,
        label: 'Ayuda > Debug > Progress: Tight loop for 120 Seconds',
        placement: 'MenuBar',
        name: 'Progress: Tight loop for 120 Seconds',
    },
    {
        id: 2164260882,
        label: 'Ayuda > Debug > Responsive Rate Test',
        placement: 'MenuBar',
        name: 'Responsive Rate Test',
    },
    {
        id: 2164260883,
        label: 'Ayuda > Debug > Test Notification 1',
        placement: 'MenuBar',
        name: 'Test Notification 1',
    },
    {
        id: 2164260884,
        label: 'Ayuda > Debug > Test Notification 2',
        placement: 'MenuBar',
        name: 'Test Notification 2',
    },
    {
        id: 2164260885,
        label: 'Ayuda > Debug > Test Notification 3',
        placement: 'MenuBar',
        name: 'Test Notification 3',
    },
    {
        id: 2164260887,
        label: 'Ayuda > Debug > Count Objects',
        placement: 'MenuBar',
        name: 'Count Objects',
    },
    {
        id: 2164260888,
        label: 'Ayuda > Debug > Object Counts',
        placement: 'MenuBar',
        name: 'Object Counts',
    },
    {
        id: 2164260890,
        label: 'Ayuda > Debug > Track API Refs',
        placement: 'MenuBar',
        name: 'Track API Refs',
    },
    {
        id: 2164260891,
        label: 'Ayuda > Debug > Process Deep Link',
        placement: 'MenuBar',
        name: 'Process Deep Link',
    },
    {
        id: 2164260892,
        label: 'Ayuda > Debug > Start Discover Panel Tour',
        placement: 'MenuBar',
        name: 'Start Discover Panel Tour',
    },
    {
        id: 2164260894,
        label: 'Ayuda > Debug > Enable New Rendering',
        placement: 'MenuBar',
        name: 'Enable New Rendering',
    },
    {
        id: 2164260895,
        label: 'Ayuda > Debug > Enable Rendering Timer',
        placement: 'MenuBar',
        name: 'Enable Rendering Timer',
    },
    {
        id: 2164260896,
        label: 'Ayuda > Debug > Purge Rendering Cache',
        placement: 'MenuBar',
        name: 'Purge Rendering Cache',
    },
    {
        id: 2164260897,
        label: 'Ayuda > Debug > Redraw',
        placement: 'MenuBar',
        name: 'Redraw',
    },
    {
        id: 2164260898,
        label: 'Ayuda > Debug > Dump Application Heap Used',
        placement: 'MenuBar',
        name: 'Dump Application Heap Used',
    },
    {
        id: 2164260899,
        label: 'Ayuda > Debug > Disable Greeking for New Rendering',
        placement: 'MenuBar',
        name: 'Disable Greeking for New Rendering',
    },
    {
        id: 2164260900,
        label: 'Ayuda > Debug > Enable Threaded Rendering',
        placement: 'MenuBar',
        name: 'Enable Threaded Rendering',
    },
    {
        id: 2164260901,
        label: 'Ayuda > Debug > Enable AGM Threading',
        placement: 'MenuBar',
        name: 'Enable AGM Threading',
    },
    {
        id: 2164260902,
        label: 'Ayuda > Debug > Enable AGM Internal Memory Pool',
        placement: 'MenuBar',
        name: 'Enable AGM Internal Memory Pool',
    },
    {
        id: 2164260903,
        label: 'Ayuda > Debug > Enable QuickPort Quartz',
        placement: 'MenuBar',
        name: 'Enable QuickPort Quartz',
    },
    {
        id: 2164260904,
        label: 'Ayuda > Debug > Crash',
        placement: 'MenuBar',
        name: 'Crash',
    },
    {
        id: 2164260906,
        label: 'Ayuda > Debug > Enable PGF Recovery',
        placement: 'MenuBar',
        name: 'Enable PGF Recovery',
    },
    {
        id: 2164260907,
        label: 'Ayuda > Debug > Enable ATE Read Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Read Recovery',
    },
    {
        id: 2164260908,
        label: 'Ayuda > Debug > Enable ATE Write Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Write Recovery',
    },
    {
        id: 2164260910,
        label: 'Ventana > Información',
        placement: 'MenuBar',
        name: 'Información',
    },
    {
        id: 2164260912,
        label: 'Ventana > Texto > Carácter',
        placement: 'MenuBar',
        name: 'Carácter',
    },
    {
        id: 2164260913,
        label: 'Ventana > Texto > Párrafo',
        placement: 'MenuBar',
        name: 'Párrafo',
    },
    {
        id: 2164260914,
        label: 'Ventana > Texto > Tabuladores',
        placement: 'MenuBar',
        name: 'Tabuladores',
    },
    {
        id: 2164260915,
        label: 'Ventana > Texto > OpenType',
        placement: 'MenuBar',
        name: 'OpenType',
    },
    {
        id: 2164260916,
        label: 'Efecto > Efectos de Photoshop',
        placement: 'MenuBar',
        name: 'Efectos de Photoshop',
    },
    {
        id: 2164260919,
        label: 'Efecto > Desenfocar > Desenfoque suavizado...',
        placement: 'MenuBar',
        name: 'Desenfoque suavizado...',
    },
    {
        id: 2164260920,
        label: 'Efecto > Desenfocar > Desenfoque radial...',
        placement: 'MenuBar',
        name: 'Desenfoque radial...',
    },
    {
        id: 2164260922,
        label: 'Efecto > Pixelizar > Puntillista...',
        placement: 'MenuBar',
        name: 'Puntillista...',
    },
    {
        id: 2164260923,
        label: 'Efecto > Pixelizar > Grabado...',
        placement: 'MenuBar',
        name: 'Grabado...',
    },
    {
        id: 2164260925,
        label: 'Efecto > Vídeo > Desentrelazar...',
        placement: 'MenuBar',
        name: 'Desentrelazar...',
    },
    {
        id: 2164260926,
        label: 'Efecto > Pixelizar > Cristalizar...',
        placement: 'MenuBar',
        name: 'Cristalizar...',
    },
    {
        id: 2164260927,
        label: 'Efecto > Pixelizar > Semitono de color...',
        placement: 'MenuBar',
        name: 'Semitono de color...',
    },
    {
        id: 2164260928,
        label: 'Efecto > Vídeo > Colores NTSC',
        placement: 'MenuBar',
        name: 'Colores NTSC',
    },
    {
        id: 2164260930,
        label: 'Efecto > Artístico > Color diluido...',
        placement: 'MenuBar',
        name: 'Color diluido...',
    },
    {
        id: 2164260932,
        label: 'Efecto > Bosquejar > Papel húmedo...',
        placement: 'MenuBar',
        name: 'Papel húmedo...',
    },
    {
        id: 2164260933,
        label: 'Efecto > Artístico > Pintar debajo...',
        placement: 'MenuBar',
        name: 'Pintar debajo...',
    },
    {
        id: 2164260934,
        label: 'Efecto > Bosquejar > Bordes rasgados...',
        placement: 'MenuBar',
        name: 'Bordes rasgados...',
    },
    {
        id: 2164260936,
        label: 'Efecto > Textura > Texturizar...',
        placement: 'MenuBar',
        name: 'Texturizar...',
    },
    {
        id: 2164260938,
        label: 'Efecto > Trazos de pincel > Sumi-e...',
        placement: 'MenuBar',
        name: 'Sumi-e...',
    },
    {
        id: 2164260939,
        label: 'Efecto > Bosquejar > Tampón...',
        placement: 'MenuBar',
        name: 'Tampón...',
    },
    {
        id: 2164260940,
        label: 'Efecto > Textura > Vidriera...',
        placement: 'MenuBar',
        name: 'Vidriera...',
    },
    {
        id: 2164260941,
        label: 'Efecto > Trazos de pincel > Trazos con spray...',
        placement: 'MenuBar',
        name: 'Trazos con spray...',
    },
    {
        id: 2164260942,
        label: 'Efecto > Artístico > Esponja...',
        placement: 'MenuBar',
        name: 'Esponja...',
    },
    {
        id: 2164260943,
        label: 'Efecto > Trazos de pincel > Salpicaduras...',
        placement: 'MenuBar',
        name: 'Salpicaduras...',
    },
    {
        id: 2164260944,
        label: 'Efecto > Artístico > Manchas...',
        placement: 'MenuBar',
        name: 'Manchas...',
    },
    {
        id: 2164260945,
        label: 'Efecto > Artístico > Trazos pastel...',
        placement: 'MenuBar',
        name: 'Trazos pastel...',
    },
    {
        id: 2164260946,
        label: 'Efecto > Bosquejar > Reticulación...',
        placement: 'MenuBar',
        name: 'Reticulación...',
    },
    {
        id: 2164260947,
        label: 'Efecto > Artístico > Bordes añadidos...',
        placement: 'MenuBar',
        name: 'Bordes añadidos...',
    },
    {
        id: 2164260948,
        label: 'Efecto > Artístico > Plastificado...',
        placement: 'MenuBar',
        name: 'Plastificado...',
    },
    {
        id: 2164260949,
        label: 'Efecto > Bosquejar > Escayola...',
        placement: 'MenuBar',
        name: 'Escayola...',
    },
    {
        id: 2164260950,
        label: 'Efecto > Bosquejar > Fotocopia...',
        placement: 'MenuBar',
        name: 'Fotocopia...',
    },
    {
        id: 2164260951,
        label: 'Efecto > Textura > Retazos...',
        placement: 'MenuBar',
        name: 'Retazos...',
    },
    {
        id: 2164260952,
        label: 'Efecto > Artístico > Espátula...',
        placement: 'MenuBar',
        name: 'Espátula...',
    },
    {
        id: 2164260953,
        label: 'Efecto > Artístico > Pinceladas...',
        placement: 'MenuBar',
        name: 'Pinceladas...',
    },
    {
        id: 2164260955,
        label: 'Efecto > Distorsionar > Ondas marinas...',
        placement: 'MenuBar',
        name: 'Ondas marinas...',
    },
    {
        id: 2164260956,
        label: 'Efecto > Bosquejar > Papel con relieve...',
        placement: 'MenuBar',
        name: 'Papel con relieve...',
    },
    {
        id: 2164260957,
        label: 'Efecto > Artístico > Resplandor de neón...',
        placement: 'MenuBar',
        name: 'Resplandor de neón...',
    },
    {
        id: 2164260958,
        label: 'Efecto > Textura > Azulejo de mosaico...',
        placement: 'MenuBar',
        name: 'Azulejo de mosaico...',
    },
    {
        id: 2164260959,
        label: 'Efecto > Trazos de pincel > Contornos con tinta...',
        placement: 'MenuBar',
        name: 'Contornos con tinta...',
    },
    {
        id: 2164260960,
        label: 'Efecto > Bosquejar > Modelo de semitono...',
        placement: 'MenuBar',
        name: 'Modelo de semitono...',
    },
    {
        id: 2164260961,
        label: 'Efecto > Bosquejar > Estilográfica...',
        placement: 'MenuBar',
        name: 'Estilográfica...',
    },
    {
        id: 2164260962,
        label: 'Efecto > Textura > Granulado...',
        placement: 'MenuBar',
        name: 'Granulado...',
    },
    {
        id: 2164260964,
        label: 'Efecto > Estilizar > Bordes resplandecientes...',
        placement: 'MenuBar',
        name: 'Bordes resplandecientes...',
    },
    {
        id: 2164260965,
        label: 'Efecto > Distorsionar > Cristal...',
        placement: 'MenuBar',
        name: 'Cristal...',
    },
    {
        id: 2164260966,
        label: 'Efecto > Artístico > Fresco...',
        placement: 'MenuBar',
        name: 'Fresco...',
    },
    {
        id: 2164260967,
        label: 'Efecto > Artístico > Película granulada...',
        placement: 'MenuBar',
        name: 'Película granulada...',
    },
    {
        id: 2164260968,
        label: 'Efecto > Artístico > Pincel seco...',
        placement: 'MenuBar',
        name: 'Pincel seco...',
    },
    {
        id: 2164260969,
        label: 'Efecto > Distorsionar > Resplandor difuso...',
        placement: 'MenuBar',
        name: 'Resplandor difuso...',
    },
    {
        id: 2164260970,
        label: 'Efecto > Trazos de pincel > Trazos oscuros...',
        placement: 'MenuBar',
        name: 'Trazos oscuros...',
    },
    {
        id: 2164260971,
        label: 'Efecto > Artístico > Cuarteado...',
        placement: 'MenuBar',
        name: 'Cuarteado...',
    },
    {
        id: 2164260972,
        label: 'Efecto > Trazos de pincel > Sombreado...',
        placement: 'MenuBar',
        name: 'Sombreado...',
    },
    {
        id: 2164260973,
        label: 'Efecto > Textura > Grietas...',
        placement: 'MenuBar',
        name: 'Grietas...',
    },
    {
        id: 2164260974,
        label: 'Efecto > Bosquejar > Conté Crayon...',
        placement: 'MenuBar',
        name: 'Conté Crayon...',
    },
    {
        id: 2164260975,
        label: 'Efecto > Artístico > Lápiz de color...',
        placement: 'MenuBar',
        name: 'Lápiz de color...',
    },
    {
        id: 2164260976,
        label: 'Efecto > Bosquejar > Cromo...',
        placement: 'MenuBar',
        name: 'Cromo...',
    },
    {
        id: 2164260977,
        label: 'Efecto > Bosquejar > Carboncillo...',
        placement: 'MenuBar',
        name: 'Carboncillo...',
    },
    {
        id: 2164260978,
        label: 'Efecto > Bosquejar > Tiza y carboncillo...',
        placement: 'MenuBar',
        name: 'Tiza y carboncillo...',
    },
    {
        id: 2164260979,
        label: 'Efecto > Bosquejar > Bajorrelieve...',
        placement: 'MenuBar',
        name: 'Bajorrelieve...',
    },
    {
        id: 2164260980,
        label: 'Efecto > Trazos de pincel > Trazos angulares...',
        placement: 'MenuBar',
        name: 'Trazos angulares...',
    },
    {
        id: 2164260981,
        label: 'Efecto > Trazos de pincel > Bordes acentuados...',
        placement: 'MenuBar',
        name: 'Bordes acentuados...',
    },
    {
        id: 2164260982,
        label: 'Efecto > Galería de efectos...',
        placement: 'MenuBar',
        name: 'Galería de efectos...',
    },
    {
        id: 2164260983,
        label: 'Edición > Editar diccionario personalizado...',
        placement: 'MenuBar',
        name: 'Editar diccionario personalizado...',
    },
    {
        id: 2164260986,
        label: 'Objeto > Trazado > Filas y columnas…',
        placement: 'MenuBar',
        name: 'Filas y columnas…',
    },
    {
        id: 2164260988,
        label: 'Texto > Cambiar mayús./minús. > MAYÚSCULAS',
        placement: 'MenuBar',
        name: 'MAYÚSCULAS',
    },
    {
        id: 2164260989,
        label: 'Texto > Cambiar mayús./minús. > minúsculas',
        placement: 'MenuBar',
        name: 'minúsculas',
    },
    {
        id: 2164260990,
        label: 'Texto > Cambiar mayús./minús. > Tipo Título',
        placement: 'MenuBar',
        name: 'Tipo Título',
    },
    {
        id: 2164260991,
        label: 'Texto > Cambiar mayús./minús. > Tipo frase',
        placement: 'MenuBar',
        name: 'Tipo frase',
    },
    {
        id: 2164260992,
        label: 'Texto > Alineación óptica de margen',
        placement: 'MenuBar',
        name: 'Alineación óptica de margen',
    },
    {
        id: 2164260993,
        label: 'Texto > Buscar/Reemplazar fuente...',
        placement: 'MenuBar',
        name: 'Buscar/Reemplazar fuente...',
    },
    {
        id: 2164260994,
        label: 'Texto > Puntuación inteligente...',
        placement: 'MenuBar',
        name: 'Puntuación inteligente...',
    },
    {
        id: 2164260995,
        label: 'Efecto > Efectos de Illustrator',
        placement: 'MenuBar',
        name: 'Efectos de Illustrator',
    },
    {
        id: 2164260998,
        label: 'Efecto > Distorsionar y transformar > Transformar...',
        placement: 'MenuBar',
        name: 'Transformar...',
    },
    {
        id: 2164260999,
        label: 'Objeto > Transformar > Transformar individualmente...',
        placement: 'MenuBar',
        name: 'Transformar individualmente...',
    },
    {
        id: 2164261001,
        label: 'Ventana > Bibliotecas',
        placement: 'MenuBar',
        name: 'Bibliotecas',
    },
    {
        id: 2164261003,
        label: 'Ventana > Encontrar extensiones en Exchange...',
        placement: 'MenuBar',
        name: 'Encontrar extensiones en Exchange...',
    },
    {
        id: 2164261004,
        label: 'Objeto > Crear malla de degradado...',
        placement: 'MenuBar',
        name: 'Crear malla de degradado...',
    },
    {
        id: 2164261005,
        label: 'Ventana > Previsualizar separaciones',
        placement: 'MenuBar',
        name: 'Previsualizar separaciones',
    },
    {
        id: 2164261006,
        label: 'Ventana > Enlaces',
        placement: 'MenuBar',
        name: 'Enlaces',
    },
    {
        id: 2164261008,
        label: 'Edición > Editar original',
        placement: 'MenuBar',
        name: 'Editar original',
    },
    {
        id: 2164261010,
        label: 'Ventana > Texto > Estilos de párrafo',
        placement: 'MenuBar',
        name: 'Estilos de párrafo',
    },
    {
        id: 2164261011,
        label: 'Ventana > Texto > Estilos de carácter',
        placement: 'MenuBar',
        name: 'Estilos de carácter',
    },
    {
        id: 2164261012,
        label: 'Ventana > Mesas de trabajo',
        placement: 'MenuBar',
        name: 'Mesas de trabajo',
    },
    {
        id: 2164261014,
        label: 'Objeto > Mesas de trabajo > Reorganizar todas las mesas de trabajo',
        placement: 'MenuBar',
        name: 'Reorganizar todas las mesas de trabajo',
    },
    {
        id: 2164261016,
        label: 'Objeto > Mesas de trabajo > Encajar en límites de ilustración',
        placement: 'MenuBar',
        name: 'Encajar en límites de ilustración',
    },
    {
        id: 2164261017,
        label: 'Objeto > Mesas de trabajo > Encajar en ilustración seleccionada',
        placement: 'MenuBar',
        name: 'Encajar en ilustración seleccionada',
    },
    {
        id: 2164261018,
        label: 'Ventana > Propiedades',
        placement: 'MenuBar',
        name: 'Propiedades',
    },
    {
        id: 2164261019,
        label: 'Ventana > Navegador',
        placement: 'MenuBar',
        name: 'Navegador',
    },
    {
        id: 2164261022,
        label: 'Ventana > Espacio de trabajo > Restaurar Getting Started',
        placement: 'MenuBar',
        name: 'Restaurar Getting Started',
    },
    {
        id: 2164261023,
        label: 'Ventana > Espacio de trabajo > Nuevo espacio de trabajo...',
        placement: 'MenuBar',
        name: 'Nuevo espacio de trabajo...',
    },
    {
        id: 2164261024,
        label: 'Ventana > Espacio de trabajo > Gestionar espacios de trabajo...',
        placement: 'MenuBar',
        name: 'Gestionar espacios de trabajo...',
    },
    {
        id: 2164261025,
        label: 'Ventana > Espacio de trabajo > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261026,
        label: 'Ventana > Espacio de trabajo > Impresión y pruebas',
        placement: 'MenuBar',
        name: 'Impresión y pruebas',
    },
    {
        id: 2164261027,
        label: 'Ventana > Espacio de trabajo > Pintura',
        placement: 'MenuBar',
        name: 'Pintura',
    },
    {
        id: 2164261028,
        label: 'Ventana > Espacio de trabajo > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261029,
        label: 'Ventana > Espacio de trabajo > Aspectos esenciales',
        placement: 'MenuBar',
        name: 'Aspectos esenciales',
    },
    {
        id: 2164261030,
        label: 'Ventana > Espacio de trabajo > Tipografía',
        placement: 'MenuBar',
        name: 'Tipografía',
    },
    {
        id: 2164261031,
        label: 'Ventana > Espacio de trabajo > Diseño',
        placement: 'MenuBar',
        name: 'Diseño',
    },
    {
        id: 2164261032,
        label: 'Ventana > Espacio de trabajo > Trazado',
        placement: 'MenuBar',
        name: 'Trazado',
    },
    {
        id: 2164261033,
        label: 'Ventana > Espacio de trabajo > Automatización',
        placement: 'MenuBar',
        name: 'Automatización',
    },
    {
        id: 2164261034,
        label: 'Ventana > Espacio de trabajo > Aspectos esenciales clásicos',
        placement: 'MenuBar',
        name: 'Aspectos esenciales clásicos',
    },
    {
        id: 2164261035,
        label: 'Edición > Métodos abreviados de teclado...',
        placement: 'MenuBar',
        name: 'Métodos abreviados de teclado...',
    },
    {
        id: 2164261036,
        label: 'Ventana > Estilos gráficos',
        placement: 'MenuBar',
        name: 'Estilos gráficos',
    },
    {
        id: 2164261037,
        label: 'Ventana > Apariencia',
        placement: 'MenuBar',
        name: 'Apariencia',
    },
    {
        id: 2164261043,
        label: 'Ventana > Bibliotecas de estilos gráficos > Aditivo para pincel de manchas',
        placement: 'MenuBar',
        name: 'Aditivo para pincel de manchas',
    },
    {
        id: 2164261044,
        label: 'Ventana > Bibliotecas de estilos gráficos > Aditivo',
        placement: 'MenuBar',
        name: 'Aditivo',
    },
    {
        id: 2164261045,
        label: 'Ventana > Bibliotecas de estilos gráficos > Botones y Rollovers',
        placement: 'MenuBar',
        name: 'Botones y Rollovers',
    },
    {
        id: 2164261046,
        label: 'Ventana > Bibliotecas de estilos gráficos > Efectos 3D',
        placement: 'MenuBar',
        name: 'Efectos 3D',
    },
    {
        id: 2164261047,
        label: 'Ventana > Bibliotecas de estilos gráficos > Efectos artísticos',
        placement: 'MenuBar',
        name: 'Efectos artísticos',
    },
    {
        id: 2164261048,
        label: 'Ventana > Bibliotecas de estilos gráficos > Efectos de garabatear',
        placement: 'MenuBar',
        name: 'Efectos de garabatear',
    },
    {
        id: 2164261049,
        label: 'Ventana > Bibliotecas de estilos gráficos > Efectos de imagen',
        placement: 'MenuBar',
        name: 'Efectos de imagen',
    },
    {
        id: 2164261050,
        label: 'Ventana > Bibliotecas de estilos gráficos > Efectos de neón',
        placement: 'MenuBar',
        name: 'Efectos de neón',
    },
    {
        id: 2164261051,
        label: 'Ventana > Bibliotecas de estilos gráficos > Efectos de texto',
        placement: 'MenuBar',
        name: 'Efectos de texto',
    },
    {
        id: 2164261052,
        label: 'Ventana > Bibliotecas de estilos gráficos > Estilos de motivos Vonster',
        placement: 'MenuBar',
        name: 'Estilos de motivos Vonster',
    },
    {
        id: 2164261053,
        label: 'Ventana > Bibliotecas de estilos gráficos > Estilos iluminación',
        placement: 'MenuBar',
        name: 'Estilos iluminación',
    },
    {
        id: 2164261054,
        label: 'Ventana > Bibliotecas de estilos gráficos > Texturas',
        placement: 'MenuBar',
        name: 'Texturas',
    },
    {
        id: 2164261057,
        label: 'Ventana > Bibliotecas de estilos gráficos > Otra biblioteca...',
        placement: 'MenuBar',
        name: 'Otra biblioteca...',
    },
    {
        id: 2164261058,
        label: 'Ventana > Símbolos',
        placement: 'MenuBar',
        name: 'Símbolos',
    },
    {
        id: 2164261060,
        label: 'Ventana > Bibliotecas de símbolos > Botones y barras Web',
        placement: 'MenuBar',
        name: 'Botones y barras Web',
    },
    {
        id: 2164261061,
        label: 'Ventana > Bibliotecas de símbolos > Celebración',
        placement: 'MenuBar',
        name: 'Celebración',
    },
    {
        id: 2164261062,
        label: 'Ventana > Bibliotecas de símbolos > Ciencia loca',
        placement: 'MenuBar',
        name: 'Ciencia loca',
    },
    {
        id: 2164261063,
        label: 'Ventana > Bibliotecas de símbolos > Cintas iluminación',
        placement: 'MenuBar',
        name: 'Cintas iluminación',
    },
    {
        id: 2164261064,
        label: 'Ventana > Bibliotecas de símbolos > Comunicación',
        placement: 'MenuBar',
        name: 'Comunicación',
    },
    {
        id: 2164261065,
        label: 'Ventana > Bibliotecas de símbolos > Elementos de logotipo',
        placement: 'MenuBar',
        name: 'Elementos de logotipo',
    },
    {
        id: 2164261066,
        label: 'Ventana > Bibliotecas de símbolos > Flechas',
        placement: 'MenuBar',
        name: 'Flechas',
    },
    {
        id: 2164261067,
        label: 'Ventana > Bibliotecas de símbolos > Flores',
        placement: 'MenuBar',
        name: 'Flores',
    },
    {
        id: 2164261068,
        label: 'Ventana > Bibliotecas de símbolos > Gráficas',
        placement: 'MenuBar',
        name: 'Gráficas',
    },
    {
        id: 2164261069,
        label: 'Ventana > Bibliotecas de símbolos > Gráficos de flujo iluminación',
        placement: 'MenuBar',
        name: 'Gráficos de flujo iluminación',
    },
    {
        id: 2164261070,
        label: 'Ventana > Bibliotecas de símbolos > Iconos Web',
        placement: 'MenuBar',
        name: 'Iconos Web',
    },
    {
        id: 2164261071,
        label: 'Ventana > Bibliotecas de símbolos > Indígena',
        placement: 'MenuBar',
        name: 'Indígena',
    },
    {
        id: 2164261072,
        label: 'Ventana > Bibliotecas de símbolos > Joya de familia',
        placement: 'MenuBar',
        name: 'Joya de familia',
    },
    {
        id: 2164261073,
        label: 'Ventana > Bibliotecas de símbolos > Mapas',
        placement: 'MenuBar',
        name: 'Mapas',
    },
    {
        id: 2164261074,
        label: 'Ventana > Bibliotecas de símbolos > Moda',
        placement: 'MenuBar',
        name: 'Moda',
    },
    {
        id: 2164261075,
        label: 'Ventana > Bibliotecas de símbolos > Móvil',
        placement: 'MenuBar',
        name: 'Móvil',
    },
    {
        id: 2164261076,
        label: 'Ventana > Bibliotecas de símbolos > Naturaleza',
        placement: 'MenuBar',
        name: 'Naturaleza',
    },
    {
        id: 2164261077,
        label: 'Ventana > Bibliotecas de símbolos > Organigrama iluminación',
        placement: 'MenuBar',
        name: 'Organigrama iluminación',
    },
    {
        id: 2164261078,
        label: 'Ventana > Bibliotecas de símbolos > Paquete de vectores florales',
        placement: 'MenuBar',
        name: 'Paquete de vectores florales',
    },
    {
        id: 2164261079,
        label: 'Ventana > Bibliotecas de símbolos > Paquete de vectores majestuoso',
        placement: 'MenuBar',
        name: 'Paquete de vectores majestuoso',
    },
    {
        id: 2164261080,
        label: 'Ventana > Bibliotecas de símbolos > Paquete de vectores motivo de puntos',
        placement: 'MenuBar',
        name: 'Paquete de vectores motivo de puntos',
    },
    {
        id: 2164261081,
        label: 'Ventana > Bibliotecas de símbolos > Paquete de vectores suciedad',
        placement: 'MenuBar',
        name: 'Paquete de vectores suciedad',
    },
    {
        id: 2164261082,
        label: 'Ventana > Bibliotecas de símbolos > Pelo y pelaje',
        placement: 'MenuBar',
        name: 'Pelo y pelaje',
    },
    {
        id: 2164261083,
        label: 'Ventana > Bibliotecas de símbolos > Retro',
        placement: 'MenuBar',
        name: 'Retro',
    },
    {
        id: 2164261084,
        label: 'Ventana > Bibliotecas de símbolos > Símbolos 3D',
        placement: 'MenuBar',
        name: 'Símbolos 3D',
    },
    {
        id: 2164261085,
        label: 'Ventana > Bibliotecas de símbolos > Sushi',
        placement: 'MenuBar',
        name: 'Sushi',
    },
    {
        id: 2164261086,
        label: 'Ventana > Bibliotecas de símbolos > Texturas artísticas',
        placement: 'MenuBar',
        name: 'Texturas artísticas',
    },
    {
        id: 2164261087,
        label: 'Ventana > Bibliotecas de símbolos > Tiki',
        placement: 'MenuBar',
        name: 'Tiki',
    },
    {
        id: 2164261090,
        label: 'Ventana > Bibliotecas de símbolos > Otra biblioteca...',
        placement: 'MenuBar',
        name: 'Otra biblioteca...',
    },
    {
        id: 2164261092,
        label: 'Ver > Guías inteligentes',
        placement: 'MenuBar',
        name: 'Guías inteligentes',
    },
    {
        id: 2164261093,
        label: 'Ventana > Previsualizar acomplamiento',
        placement: 'MenuBar',
        name: 'Previsualizar acomplamiento',
    },
    {
        id: 2164261094,
        label: 'Ventana > Historial',
        placement: 'MenuBar',
        name: 'Historial',
    },
    {
        id: 2164261096,
        label: 'Texto > Glifos',
        placement: 'MenuBar',
        name: 'Glifos',
    },
    {
        id: 2164261097,
        label: 'Ventana > Texto > Glifos',
        placement: 'MenuBar',
        name: 'Glifos',
    },
    {
        id: 2164261098,
        label: 'Ventana > Acciones',
        placement: 'MenuBar',
        name: 'Acciones',
    },
    {
        id: 2164261100,
        label: 'Seleccionar > Invertir',
        placement: 'MenuBar',
        name: 'Invertir',
    },
    {
        id: 2164261102,
        label: 'Efecto > Estilizar > Sombra paralela...',
        placement: 'MenuBar',
        name: 'Sombra paralela...',
    },
    {
        id: 2164261103,
        label: 'Efecto > Estilizar > Resplandor exterior...',
        placement: 'MenuBar',
        name: 'Resplandor exterior...',
    },
    {
        id: 2164261104,
        label: 'Efecto > Estilizar > Resplandor interior...',
        placement: 'MenuBar',
        name: 'Resplandor interior...',
    },
    {
        id: 2164261106,
        label: 'Efecto > Convertir en forma > Rectángulo...',
        placement: 'MenuBar',
        name: 'Rectángulo...',
    },
    {
        id: 2164261107,
        label: 'Efecto > Convertir en forma > Rectángulo redondeado...',
        placement: 'MenuBar',
        name: 'Rectángulo redondeado...',
    },
    {
        id: 2164261108,
        label: 'Efecto > Convertir en forma > Elipse...',
        placement: 'MenuBar',
        name: 'Elipse...',
    },
    {
        id: 2164261109,
        label: 'Efecto > Estilizar > Redondear vértices...',
        placement: 'MenuBar',
        name: 'Redondear vértices...',
    },
    {
        id: 2164261111,
        label: 'Objeto > Trazado > Limpiar...',
        placement: 'MenuBar',
        name: 'Limpiar...',
    },
    {
        id: 2164261113,
        label: 'Edición > Editar colores > Sobreimprimir negro...',
        placement: 'MenuBar',
        name: 'Sobreimprimir negro...',
    },
    {
        id: 2164261114,
        label: 'Efecto > Distorsionar y transformar > Distorsión libre...',
        placement: 'MenuBar',
        name: 'Distorsión libre...',
    },
    {
        id: 2164261115,
        label: 'Efecto > Distorsionar y transformar > Fruncir y engordar...',
        placement: 'MenuBar',
        name: 'Fruncir y engordar...',
    },
    {
        id: 2164261117,
        label: 'Objeto > Ceñir texto > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 2164261118,
        label: 'Objeto > Ceñir texto > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 2164261120,
        label: 'Objeto > Ceñir texto > Opciones de Ceñir texto...',
        placement: 'MenuBar',
        name: 'Opciones de Ceñir texto...',
    },
    {
        id: 2164261121,
        label: 'Efecto > Distorsionar y transformar > Ajustar...',
        placement: 'MenuBar',
        name: 'Ajustar...',
    },
    {
        id: 2164261122,
        label: 'Seleccionar > Objeto > Máscaras de recorte',
        placement: 'MenuBar',
        name: 'Máscaras de recorte',
    },
    {
        id: 2164261123,
        label: 'Edición > Editar colores > Fusión de frente a fondo',
        placement: 'MenuBar',
        name: 'Fusión de frente a fondo',
    },
    {
        id: 2164261124,
        label: 'Edición > Editar colores > Fusión horizontal',
        placement: 'MenuBar',
        name: 'Fusión horizontal',
    },
    {
        id: 2164261125,
        label: 'Edición > Editar colores > Fusión vertical',
        placement: 'MenuBar',
        name: 'Fusión vertical',
    },
    {
        id: 2164261126,
        label: 'Edición > Editar colores > Invertir colores',
        placement: 'MenuBar',
        name: 'Invertir colores',
    },
    {
        id: 2164261127,
        label: 'Edición > Editar colores > Convertir a escala de grises',
        placement: 'MenuBar',
        name: 'Convertir a escala de grises',
    },
    {
        id: 2164261128,
        label: 'Edición > Editar colores > Convertir a CMYK',
        placement: 'MenuBar',
        name: 'Convertir a CMYK',
    },
    {
        id: 2164261129,
        label: 'Edición > Editar colores > Convertir a RGB',
        placement: 'MenuBar',
        name: 'Convertir a RGB',
    },
    {
        id: 2164261130,
        label: 'Edición > Editar colores > Saturar...',
        placement: 'MenuBar',
        name: 'Saturar...',
    },
    {
        id: 2164261132,
        label: 'Objeto > Trazado > Añadir puntos de ancla',
        placement: 'MenuBar',
        name: 'Añadir puntos de ancla',
    },
    {
        id: 2164261133,
        label: 'Edición > Editar colores > Ajustar equilibrio de colores...',
        placement: 'MenuBar',
        name: 'Ajustar equilibrio de colores...',
    },
    {
        id: 2164261134,
        label: 'Objeto > Crear mosaico de objetos...',
        placement: 'MenuBar',
        name: 'Crear mosaico de objetos...',
    },
    {
        id: 2164261135,
        label: 'Efecto > Distorsionar y transformar > Emborronar...',
        placement: 'MenuBar',
        name: 'Emborronar...',
    },
    {
        id: 2164261136,
        label: 'Seleccionar > Volver a seleccionar',
        placement: 'MenuBar',
        name: 'Volver a seleccionar',
    },
    {
        id: 2164261138,
        label: 'Seleccionar > Mismo > Formas y texto',
        placement: 'MenuBar',
        name: 'Formas y texto',
    },
    {
        id: 2164261139,
        label: 'Seleccionar > Mismo > Texto',
        placement: 'MenuBar',
        name: 'Texto',
    },
    {
        id: 2164261141,
        label: 'Seleccionar > Mismo > Color de relleno',
        placement: 'MenuBar',
        name: 'Color de relleno',
    },
    {
        id: 2164261142,
        label: 'Seleccionar > Mismo > Estilo gráfico',
        placement: 'MenuBar',
        name: 'Estilo gráfico',
    },
    {
        id: 2164261143,
        label: 'Seleccionar > Mismo > Relleno y trazo',
        placement: 'MenuBar',
        name: 'Relleno y trazo',
    },
    {
        id: 2164261144,
        label: 'Seleccionar > Mismo > Color de trazo',
        placement: 'MenuBar',
        name: 'Color de trazo',
    },
    {
        id: 2164261145,
        label: 'Seleccionar > Mismo > Grosor de trazo',
        placement: 'MenuBar',
        name: 'Grosor de trazo',
    },
    {
        id: 2164261146,
        label: 'Seleccionar > Mismo > Modo de fusión',
        placement: 'MenuBar',
        name: 'Modo de fusión',
    },
    {
        id: 2164261147,
        label: 'Seleccionar > Mismo > Opacidad',
        placement: 'MenuBar',
        name: 'Opacidad',
    },
    {
        id: 2164261148,
        label: 'Seleccionar > Mismo > Forma',
        placement: 'MenuBar',
        name: 'Forma',
    },
    {
        id: 2164261149,
        label: 'Seleccionar > Mismo > Instancia de símbolo',
        placement: 'MenuBar',
        name: 'Instancia de símbolo',
    },
    {
        id: 2164261150,
        label: 'Seleccionar > Mismo > Enlazar serie de bloques',
        placement: 'MenuBar',
        name: 'Enlazar serie de bloques',
    },
    {
        id: 2164261151,
        label: 'Seleccionar > Mismo > Apariencia',
        placement: 'MenuBar',
        name: 'Apariencia',
    },
    {
        id: 2164261152,
        label: 'Seleccionar > Mismo > Atributo de apariencia',
        placement: 'MenuBar',
        name: 'Atributo de apariencia',
    },
    {
        id: 2164261153,
        label: 'Seleccionar > Mismo > Color de relleno de texto',
        placement: 'MenuBar',
        name: 'Color de relleno de texto',
    },
    {
        id: 2164261154,
        label: 'Seleccionar > Mismo > Color de trazo de texto',
        placement: 'MenuBar',
        name: 'Color de trazo de texto',
    },
    {
        id: 2164261155,
        label: 'Seleccionar > Mismo > Color de trazo y relleno de texto',
        placement: 'MenuBar',
        name: 'Color de trazo y relleno de texto',
    },
    {
        id: 2164261156,
        label: 'Seleccionar > Mismo > Tamaño de fuente',
        placement: 'MenuBar',
        name: 'Tamaño de fuente',
    },
    {
        id: 2164261157,
        label: 'Seleccionar > Mismo > Familia de fuentes',
        placement: 'MenuBar',
        name: 'Familia de fuentes',
    },
    {
        id: 2164261158,
        label: 'Seleccionar > Mismo > Familia de fuentes y estilo',
        placement: 'MenuBar',
        name: 'Familia de fuentes y estilo',
    },
    {
        id: 2164261159,
        label: 'Seleccionar > Mismo > Familia de fuentes, estilo y tamaño',
        placement: 'MenuBar',
        name: 'Familia de fuentes, estilo y tamaño',
    },
    {
        id: 2164261160,
        label: 'Seleccionar > Objeto > Puntos aislados',
        placement: 'MenuBar',
        name: 'Puntos aislados',
    },
    {
        id: 2164261162,
        label: 'Seleccionar > Objeto > Todos los objetos de texto',
        placement: 'MenuBar',
        name: 'Todos los objetos de texto',
    },
    {
        id: 2164261163,
        label: 'Seleccionar > Objeto > Objetos de texto de punto',
        placement: 'MenuBar',
        name: 'Objetos de texto de punto',
    },
    {
        id: 2164261164,
        label: 'Seleccionar > Objeto > Objetos de texto de área',
        placement: 'MenuBar',
        name: 'Objetos de texto de área',
    },
    {
        id: 2164261165,
        label: 'Efecto > Distorsionar y transformar > Zigzag...',
        placement: 'MenuBar',
        name: 'Zigzag...',
    },
    {
        id: 2164261166,
        label: 'Efecto > Marcas de recorte',
        placement: 'MenuBar',
        name: 'Marcas de recorte',
    },
    {
        id: 2164261167,
        label: 'Objeto > Crear marcas de límite',
        placement: 'MenuBar',
        name: 'Crear marcas de límite',
    },
    {
        id: 2164261168,
        label: 'Archivo > Empaquetar...',
        placement: 'MenuBar',
        name: 'Empaquetar...',
    },
    {
        id: 2164261169,
        label: 'Ventana > Capas',
        placement: 'MenuBar',
        name: 'Capas',
    },
    {
        id: 2164261172,
        label: 'Archivo > Explorar en Bridge...',
        placement: 'MenuBar',
        name: 'Explorar en Bridge...',
    },
    {
        id: 2164261173,
        label: 'Archivo > Información de archivo...',
        placement: 'MenuBar',
        name: 'Información de archivo...',
    },
    {
        id: 2164261174,
        label: 'Ventana > Información de documento',
        placement: 'MenuBar',
        name: 'Información de documento',
    },
    {
        id: 2164261176,
        label: 'Efecto > Buscatrazos > Añadir',
        placement: 'MenuBar',
        name: 'Añadir',
    },
    {
        id: 2164261177,
        label: 'Efecto > Buscatrazos > Formar intersección',
        placement: 'MenuBar',
        name: 'Formar intersección',
    },
    {
        id: 2164261178,
        label: 'Efecto > Buscatrazos > Excluir',
        placement: 'MenuBar',
        name: 'Excluir',
    },
    {
        id: 2164261179,
        label: 'Efecto > Buscatrazos > Restar',
        placement: 'MenuBar',
        name: 'Restar',
    },
    {
        id: 2164261180,
        label: 'Efecto > Buscatrazos > Menos fondo',
        placement: 'MenuBar',
        name: 'Menos fondo',
    },
    {
        id: 2164261181,
        label: 'Efecto > Buscatrazos > Dividir',
        placement: 'MenuBar',
        name: 'Dividir',
    },
    {
        id: 2164261182,
        label: 'Efecto > Buscatrazos > Cortar',
        placement: 'MenuBar',
        name: 'Cortar',
    },
    {
        id: 2164261183,
        label: 'Efecto > Buscatrazos > Combinar',
        placement: 'MenuBar',
        name: 'Combinar',
    },
    {
        id: 2164261184,
        label: 'Efecto > Buscatrazos > Recortar',
        placement: 'MenuBar',
        name: 'Recortar',
    },
    {
        id: 2164261185,
        label: 'Efecto > Buscatrazos > Contornear',
        placement: 'MenuBar',
        name: 'Contornear',
    },
    {
        id: 2164261186,
        label: 'Efecto > Buscatrazos > Mezcla definida',
        placement: 'MenuBar',
        name: 'Mezcla definida',
    },
    {
        id: 2164261187,
        label: 'Efecto > Buscatrazos > Mezcla suave...',
        placement: 'MenuBar',
        name: 'Mezcla suave...',
    },
    {
        id: 2164261188,
        label: 'Efecto > Buscatrazos > Reventar...',
        placement: 'MenuBar',
        name: 'Reventar...',
    },
    {
        id: 2164261189,
        label: 'Ver > Mostrar huecos de pintura interactiva',
        placement: 'MenuBar',
        name: 'Mostrar huecos de pintura interactiva',
    },
    {
        id: 2164261192,
        label: 'Objeto > Pintura interactiva > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 2164261193,
        label: 'Objeto > Pintura interactiva > Combinar',
        placement: 'MenuBar',
        name: 'Combinar',
    },
    {
        id: 2164261194,
        label: 'Objeto > Pintura interactiva > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 2164261196,
        label: 'Objeto > Pintura interactiva > Opciones de hueco...',
        placement: 'MenuBar',
        name: 'Opciones de hueco...',
    },
    {
        id: 2164261198,
        label: 'Objeto > Pintura interactiva > Expandir',
        placement: 'MenuBar',
        name: 'Expandir',
    },
    {
        id: 2164261199,
        label: 'Efecto > Estilizar > Garabatear...',
        placement: 'MenuBar',
        name: 'Garabatear...',
    },
    {
        id: 2164261201,
        label: 'Objeto > Distorsión de envolvente > Crear con deformación...',
        placement: 'MenuBar',
        name: 'Crear con deformación...',
    },
    {
        id: 2164261202,
        label: 'Objeto > Distorsión de envolvente > Crear con malla...',
        placement: 'MenuBar',
        name: 'Crear con malla...',
    },
    {
        id: 2164261203,
        label: 'Objeto > Distorsión de envolvente > Crear con objeto superior',
        placement: 'MenuBar',
        name: 'Crear con objeto superior',
    },
    {
        id: 2164261204,
        label: 'Objeto > Distorsión de envolvente > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 2164261206,
        label: 'Objeto > Distorsión de envolvente > Opciones de envolvente...',
        placement: 'MenuBar',
        name: 'Opciones de envolvente...',
    },
    {
        id: 2164261208,
        label: 'Objeto > Distorsión de envolvente > Expandir',
        placement: 'MenuBar',
        name: 'Expandir',
    },
    {
        id: 2164261210,
        label: 'Objeto > Distorsión de envolvente > Editar contenido',
        placement: 'MenuBar',
        name: 'Editar contenido',
    },
    {
        id: 2164261212,
        label: 'Efecto > Deformar > Arco...',
        placement: 'MenuBar',
        name: 'Arco...',
    },
    {
        id: 2164261213,
        label: 'Efecto > Deformar > Arco inferior...',
        placement: 'MenuBar',
        name: 'Arco inferior...',
    },
    {
        id: 2164261214,
        label: 'Efecto > Deformar > Arco superior...',
        placement: 'MenuBar',
        name: 'Arco superior...',
    },
    {
        id: 2164261215,
        label: 'Efecto > Deformar > Bóveda...',
        placement: 'MenuBar',
        name: 'Bóveda...',
    },
    {
        id: 2164261216,
        label: 'Efecto > Deformar > Abombar...',
        placement: 'MenuBar',
        name: 'Abombar...',
    },
    {
        id: 2164261217,
        label: 'Efecto > Deformar > Caparazón hacia abajo...',
        placement: 'MenuBar',
        name: 'Caparazón hacia abajo...',
    },
    {
        id: 2164261218,
        label: 'Efecto > Deformar > Caparazón hacia arriba...',
        placement: 'MenuBar',
        name: 'Caparazón hacia arriba...',
    },
    {
        id: 2164261219,
        label: 'Efecto > Deformar > Bandera...',
        placement: 'MenuBar',
        name: 'Bandera...',
    },
    {
        id: 2164261220,
        label: 'Efecto > Deformar > Onda...',
        placement: 'MenuBar',
        name: 'Onda...',
    },
    {
        id: 2164261221,
        label: 'Efecto > Deformar > Pez...',
        placement: 'MenuBar',
        name: 'Pez...',
    },
    {
        id: 2164261222,
        label: 'Efecto > Deformar > Elevar...',
        placement: 'MenuBar',
        name: 'Elevar...',
    },
    {
        id: 2164261223,
        label: 'Efecto > Deformar > Ojo de pez...',
        placement: 'MenuBar',
        name: 'Ojo de pez...',
    },
    {
        id: 2164261224,
        label: 'Efecto > Deformar > Inflar...',
        placement: 'MenuBar',
        name: 'Inflar...',
    },
    {
        id: 2164261225,
        label: 'Efecto > Deformar > Estrechar...',
        placement: 'MenuBar',
        name: 'Estrechar...',
    },
    {
        id: 2164261226,
        label: 'Efecto > Deformar > Torcer...',
        placement: 'MenuBar',
        name: 'Torcer...',
    },
    {
        id: 2164261227,
        label: 'Objeto > Expandir...',
        placement: 'MenuBar',
        name: 'Expandir...',
    },
    {
        id: 2164261229,
        label: 'Edición > Ortografía > Corrección ortográfica automática',
        placement: 'MenuBar',
        name: 'Corrección ortográfica automática',
    },
    {
        id: 2164261230,
        label: 'Edición > Ortografía > Revisar ortografía...',
        placement: 'MenuBar',
        name: 'Revisar ortografía...',
    },
    {
        id: 2164261231,
        label: 'Seleccionar > Iniciar edición global',
        placement: 'MenuBar',
        name: 'Iniciar edición global',
    },
    {
        id: 2164261232,
        label: 'Illustrator > Preferencias > Rendimiento...',
        placement: 'MenuBar',
        name: 'Rendimiento...',
    },
    {
        id: 2164261233,
        label: 'Illustrator > Preferencias > Administración de archivos...',
        placement: 'MenuBar',
        name: 'Administración de archivos...',
    },
    {
        id: 2164261234,
        label: 'Illustrator > Preferencias > Administración del portapapeles...',
        placement: 'MenuBar',
        name: 'Administración del portapapeles...',
    },
    {
        id: 2164261235,
        label: 'Illustrator > Preferencias > Apariencia de negro...',
        placement: 'MenuBar',
        name: 'Apariencia de negro...',
    },
    {
        id: 2164261236,
        label: 'Illustrator > Preferencias > Dispositivos...',
        placement: 'MenuBar',
        name: 'Dispositivos...',
    },
    {
        id: 2164261237,
        label: 'Ventana > Pinceles',
        placement: 'MenuBar',
        name: 'Pinceles',
    },
    {
        id: 2164261238,
        label: 'Seleccionar > Objeto > Trazos de pincel',
        placement: 'MenuBar',
        name: 'Trazos de pincel',
    },
    {
        id: 2164261241,
        label: 'Ventana > Bibliotecas de pinceles > Artístico > Artístico_Caligráfico',
        placement: 'MenuBar',
        name: 'Artístico_Caligráfico',
    },
    {
        id: 2164261242,
        label: 'Ventana > Bibliotecas de pinceles > Artístico > Artístico_Color diluido',
        placement: 'MenuBar',
        name: 'Artístico_Color diluido',
    },
    {
        id: 2164261243,
        label: 'Ventana > Bibliotecas de pinceles > Artístico > Artístico_LápizTizaCarboncillo',
        placement: 'MenuBar',
        name: 'Artístico_LápizTizaCarboncillo',
    },
    {
        id: 2164261244,
        label: 'Ventana > Bibliotecas de pinceles > Artístico > Artístico_Pincel',
        placement: 'MenuBar',
        name: 'Artístico_Pincel',
    },
    {
        id: 2164261245,
        label: 'Ventana > Bibliotecas de pinceles > Artístico > Artístico_Pluma múltiple',
        placement: 'MenuBar',
        name: 'Artístico_Pluma múltiple',
    },
    {
        id: 2164261246,
        label: 'Ventana > Bibliotecas de pinceles > Artístico > Artístico_Tinta',
        placement: 'MenuBar',
        name: 'Artístico_Tinta',
    },
    {
        id: 2164261248,
        label: 'Ventana > Bibliotecas de pinceles > Bordes > Bordes_Decorativo',
        placement: 'MenuBar',
        name: 'Bordes_Decorativo',
    },
    {
        id: 2164261249,
        label: 'Ventana > Bibliotecas de pinceles > Bordes > Bordes_Geométrico1',
        placement: 'MenuBar',
        name: 'Bordes_Geométrico1',
    },
    {
        id: 2164261250,
        label: 'Ventana > Bibliotecas de pinceles > Bordes > Bordes_Indígena',
        placement: 'MenuBar',
        name: 'Bordes_Indígena',
    },
    {
        id: 2164261251,
        label: 'Ventana > Bibliotecas de pinceles > Bordes > Bordes_Líneas discontinuas',
        placement: 'MenuBar',
        name: 'Bordes_Líneas discontinuas',
    },
    {
        id: 2164261252,
        label: 'Ventana > Bibliotecas de pinceles > Bordes > Bordes_Líneas',
        placement: 'MenuBar',
        name: 'Bordes_Líneas',
    },
    {
        id: 2164261253,
        label: 'Ventana > Bibliotecas de pinceles > Bordes > Bordes_Marcos',
        placement: 'MenuBar',
        name: 'Bordes_Marcos',
    },
    {
        id: 2164261254,
        label: 'Ventana > Bibliotecas de pinceles > Bordes > Bordes_Novedad',
        placement: 'MenuBar',
        name: 'Bordes_Novedad',
    },
    {
        id: 2164261256,
        label: 'Ventana > Bibliotecas de pinceles > Decorativo > Conjunto de pinceles florales y de espiral elegante',
        placement: 'MenuBar',
        name: 'Conjunto de pinceles florales y de espiral elegante',
    },
    {
        id: 2164261257,
        label: 'Ventana > Bibliotecas de pinceles > Decorativo > Decorativo_Dispersión',
        placement: 'MenuBar',
        name: 'Decorativo_Dispersión',
    },
    {
        id: 2164261258,
        label: 'Ventana > Bibliotecas de pinceles > Decorativo > Decorativo_Separadores de texto',
        placement: 'MenuBar',
        name: 'Decorativo_Separadores de texto',
    },
    {
        id: 2164261259,
        label: 'Ventana > Bibliotecas de pinceles > Decorativo > Decorativo_Titulares y sellos',
        placement: 'MenuBar',
        name: 'Decorativo_Titulares y sellos',
    },
    {
        id: 2164261261,
        label: 'Ventana > Bibliotecas de pinceles > Flechas > Flechas de motivo',
        placement: 'MenuBar',
        name: 'Flechas de motivo',
    },
    {
        id: 2164261262,
        label: 'Ventana > Bibliotecas de pinceles > Flechas > Flechas_Especial',
        placement: 'MenuBar',
        name: 'Flechas_Especial',
    },
    {
        id: 2164261263,
        label: 'Ventana > Bibliotecas de pinceles > Flechas > Flechas_Estándar',
        placement: 'MenuBar',
        name: 'Flechas_Estándar',
    },
    {
        id: 2164261265,
        label: 'Ventana > Bibliotecas de pinceles > Paquetes de vectores > Paq. vect. pinceles a mano',
        placement: 'MenuBar',
        name: 'Paq. vect. pinceles a mano',
    },
    {
        id: 2164261266,
        label: 'Ventana > Bibliotecas de pinceles > Paquetes de vectores > Paqu. vect. pinceles grunge',
        placement: 'MenuBar',
        name: 'Paqu. vect. pinceles grunge',
    },
    {
        id: 2164261268,
        label: 'Ventana > Bibliotecas de pinceles > Pincel de cerdas > Biblioteca de pincel de cerdas',
        placement: 'MenuBar',
        name: 'Biblioteca de pincel de cerdas',
    },
    {
        id: 2164261270,
        label: 'Ventana > Bibliotecas de pinceles > Pincel de imagen > Biblioteca de pinceles de imagen',
        placement: 'MenuBar',
        name: 'Biblioteca de pinceles de imagen',
    },
    {
        id: 2164261272,
        label: 'Ventana > Bibliotecas de pinceles > Pinceles 6D de Wacom > Pinceles artísticos 6d',
        placement: 'MenuBar',
        name: 'Pinceles artísticos 6d',
    },
    {
        id: 2164261275,
        label: 'Ventana > Bibliotecas de pinceles > Otra biblioteca...',
        placement: 'MenuBar',
        name: 'Otra biblioteca...',
    },
    {
        id: 2164261276,
        label: 'Ventana > Buscatrazos',
        placement: 'MenuBar',
        name: 'Buscatrazos',
    },
    {
        id: 2164261277,
        label: 'Edición > Buscar y reemplazar...',
        placement: 'MenuBar',
        name: 'Buscar y reemplazar...',
    },
    {
        id: 2164261278,
        label: 'Edición > Buscar siguiente',
        placement: 'MenuBar',
        name: 'Buscar siguiente',
    },
    {
        id: 2164261279,
        label: 'Efecto > Rasterizar...',
        placement: 'MenuBar',
        name: 'Rasterizar...',
    },
    {
        id: 2164261281,
        label: 'Efecto > Ajustes de efectos de rasterizado de documento...',
        placement: 'MenuBar',
        name: 'Ajustes de efectos de rasterizado de documento...',
    },
    {
        id: 2164261282,
        label: 'Objeto > Rasterizar…',
        placement: 'MenuBar',
        name: 'Rasterizar…',
    },
    {
        id: 2164261284,
        label: 'Objeto > Fusión > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 2164261285,
        label: 'Objeto > Fusión > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 2164261287,
        label: 'Objeto > Fusión > Opciones de fusión...',
        placement: 'MenuBar',
        name: 'Opciones de fusión...',
    },
    {
        id: 2164261289,
        label: 'Objeto > Fusión > Expandir',
        placement: 'MenuBar',
        name: 'Expandir',
    },
    {
        id: 2164261291,
        label: 'Objeto > Fusión > Reemplazar lomo',
        placement: 'MenuBar',
        name: 'Reemplazar lomo',
    },
    {
        id: 2164261292,
        label: 'Objeto > Fusión > Invertir lomo',
        placement: 'MenuBar',
        name: 'Invertir lomo',
    },
    {
        id: 2164261293,
        label: 'Objeto > Fusión > Invertir de frente a fondo',
        placement: 'MenuBar',
        name: 'Invertir de frente a fondo',
    },
    {
        id: 2164261295,
        label: 'Ver > Mostrar sectores',
        placement: 'MenuBar',
        name: 'Mostrar sectores',
    },
    {
        id: 2164261296,
        label: 'Ver > Bloquear sectores',
        placement: 'MenuBar',
        name: 'Bloquear sectores',
    },
    {
        id: 2164261299,
        label: 'Objeto > Sector > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 2164261300,
        label: 'Objeto > Sector > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 2164261302,
        label: 'Objeto > Sector > Crear desde guías',
        placement: 'MenuBar',
        name: 'Crear desde guías',
    },
    {
        id: 2164261303,
        label: 'Objeto > Sector > Crear desde selección',
        placement: 'MenuBar',
        name: 'Crear desde selección',
    },
    {
        id: 2164261305,
        label: 'Objeto > Sector > Duplicar sector',
        placement: 'MenuBar',
        name: 'Duplicar sector',
    },
    {
        id: 2164261306,
        label: 'Objeto > Sector > Combinar sectores',
        placement: 'MenuBar',
        name: 'Combinar sectores',
    },
    {
        id: 2164261307,
        label: 'Objeto > Sector > Dividir sectores...',
        placement: 'MenuBar',
        name: 'Dividir sectores...',
    },
    {
        id: 2164261308,
        label: 'Objeto > Sector > Eliminar todo',
        placement: 'MenuBar',
        name: 'Eliminar todo',
    },
    {
        id: 2164261310,
        label: 'Objeto > Sector > Opciones de sector...',
        placement: 'MenuBar',
        name: 'Opciones de sector...',
    },
    {
        id: 2164261312,
        label: 'Objeto > Sector > Recortar al tamaño de la mesa de trabajo',
        placement: 'MenuBar',
        name: 'Recortar al tamaño de la mesa de trabajo',
    },
    {
        id: 2164261313,
        label: 'Ventana > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 2164261314,
        label: 'Archivo > Guardar sectores seleccionados...',
        placement: 'MenuBar',
        name: 'Guardar sectores seleccionados...',
    },
    {
        id: 2164261316,
        label: 'Efecto > Filtros SVG > Aplicar filtro SVG...',
        placement: 'MenuBar',
        name: 'Aplicar filtro SVG...',
    },
    {
        id: 2164261317,
        label: 'Efecto > Filtros SVG > Importar filtro SVG...',
        placement: 'MenuBar',
        name: 'Importar filtro SVG...',
    },
    {
        id: 2164261319,
        label: 'Efecto > Estilizar > Desvanecer...',
        placement: 'MenuBar',
        name: 'Desvanecer...',
    },
    {
        id: 2164261321,
        label: 'Efecto > 3D y materiales > Extrusión y biselado...',
        placement: 'MenuBar',
        name: 'Extrusión y biselado...',
    },
    {
        id: 2164261322,
        label: 'Efecto > 3D y materiales > Girar...',
        placement: 'MenuBar',
        name: 'Girar...',
    },
    {
        id: 2164261323,
        label: 'Efecto > 3D y materiales > Inflar...',
        placement: 'MenuBar',
        name: 'Inflar...',
    },
    {
        id: 2164261324,
        label: 'Efecto > 3D y materiales > Rotar...',
        placement: 'MenuBar',
        name: 'Rotar...',
    },
    {
        id: 2164261325,
        label: 'Efecto > 3D y materiales > Materiales...',
        placement: 'MenuBar',
        name: 'Materiales...',
    },
    {
        id: 2164261327,
        label: 'Efecto > 3D y materiales > 3D (clásico) > Extrusión y biselado (clásico)...',
        placement: 'MenuBar',
        name: 'Extrusión y biselado (clásico)...',
    },
    {
        id: 2164261328,
        label: 'Efecto > 3D y materiales > 3D (clásico) > Giro (clásico)...',
        placement: 'MenuBar',
        name: 'Giro (clásico)...',
    },
    {
        id: 2164261329,
        label: 'Efecto > 3D y materiales > 3D (clásico) > Rotar (clásico)...',
        placement: 'MenuBar',
        name: 'Rotar (clásico)...',
    },
    {
        id: 2164261330,
        label: 'Ventana > Interactividad SVG',
        placement: 'MenuBar',
        name: 'Interactividad SVG',
    },
    {
        id: 2164261331,
        label: 'Objeto > Recortar imagen',
        placement: 'MenuBar',
        name: 'Recortar imagen',
    },
    {
        id: 2164261332,
        label: 'Ventana > Variables',
        placement: 'MenuBar',
        name: 'Variables',
    },
    {
        id: 2164261334,
        label: 'Ventana > Varita mágica',
        placement: 'MenuBar',
        name: 'Varita mágica',
    },
    {
        id: 2164261335,
        label: 'Objeto > Trazado > Dividir objetos debajo',
        placement: 'MenuBar',
        name: 'Dividir objetos debajo',
    },
    {
        id: 2164261336,
        label: 'Seleccionar > Objeto > Trazos de pincel de cerdas',
        placement: 'MenuBar',
        name: 'Trazos de pincel de cerdas',
    },
    {
        id: 2164261338,
        label: 'Objeto > Transformar > Restaurar cuadro delimitador',
        placement: 'MenuBar',
        name: 'Restaurar cuadro delimitador',
    },
    {
        id: 2164261339,
        label: 'Ver > Ocultar cuadro delimitador',
        placement: 'MenuBar',
        name: 'Ocultar cuadro delimitador',
    },
    {
        id: 2164261340,
        label: 'Objeto > Organizar > Enviar a capa actual',
        placement: 'MenuBar',
        name: 'Enviar a capa actual',
    },
    {
        id: 2164261342,
        label: 'Objeto > Bloquear > Todas las ilustraciones encima',
        placement: 'MenuBar',
        name: 'Todas las ilustraciones encima',
    },
    {
        id: 2164261343,
        label: 'Objeto > Bloquear > Otras capas',
        placement: 'MenuBar',
        name: 'Otras capas',
    },
    {
        id: 2164261344,
        label: 'Objeto > Ocultar > Todas las ilustraciones encima',
        placement: 'MenuBar',
        name: 'Todas las ilustraciones encima',
    },
    {
        id: 2164261345,
        label: 'Objeto > Ocultar > Otras capas',
        placement: 'MenuBar',
        name: 'Otras capas',
    },
    {
        id: 2164261346,
        label: 'Seleccionar > Objeto > Todo en las mismas capas',
        placement: 'MenuBar',
        name: 'Todo en las mismas capas',
    },
    {
        id: 2164261347,
        label: 'Seleccionar > Objeto > Manejadores de dirección',
        placement: 'MenuBar',
        name: 'Manejadores de dirección',
    },
    {
        id: 2164261350,
        label: 'Seleccionar > Siguiente objeto encima',
        placement: 'MenuBar',
        name: 'Siguiente objeto encima',
    },
    {
        id: 2164261351,
        label: 'Seleccionar > Siguiente objeto debajo',
        placement: 'MenuBar',
        name: 'Siguiente objeto debajo',
    },
    {
        id: 2164261354,
        label: 'Seleccionar > Guardar selección...',
        placement: 'MenuBar',
        name: 'Guardar selección...',
    },
    {
        id: 2164261355,
        label: 'Seleccionar > Editar selección...',
        placement: 'MenuBar',
        name: 'Editar selección...',
    },
    {
        id: 2164261356,
        label: 'Seleccionar > Actualizar selección',
        placement: 'MenuBar',
        name: 'Actualizar selección',
    },
    {
        id: 2164261357,
        label: 'Objeto > Trazado > Simplificar...',
        placement: 'MenuBar',
        name: 'Simplificar...',
    },
    {
        id: 2164261358,
        label: 'Objeto > Trazado > Suave...',
        placement: 'MenuBar',
        name: 'Suave...',
    },
    {
        id: 2164261360,
        label: 'Objeto > Maqueta > Vista previa de Maqueta',
        placement: 'MenuBar',
        name: 'Vista previa de Maqueta',
    },
    {
        id: 2164261361,
        label: 'Objeto > Maqueta > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 2164261362,
        label: 'Objeto > Maqueta > Edición',
        placement: 'MenuBar',
        name: 'Edición',
    },
    {
        id: 2164261363,
        label: 'Efecto > Distorsionar y transformar > Torcer...',
        placement: 'MenuBar',
        name: 'Torcer...',
    },
    {
        id: 2164261367,
        label: 'Archivo > Secuencias de comandos > Otra secuencia de comandos...',
        placement: 'MenuBar',
        name: 'Otra secuencia de comandos...',
    },
    {
        id: 2164261368,
        label: 'Ventana > Propiedades CSS (obsoleto)',
        placement: 'MenuBar',
        name: 'Propiedades CSS (obsoleto)',
    },
    {
        id: 2164261370,
        label: 'Efecto > Trazado > Contornear objeto',
        placement: 'MenuBar',
        name: 'Contornear objeto',
    },
    {
        id: 2164261371,
        label: 'Ventana > Color',
        placement: 'MenuBar',
        name: 'Color',
    },
    {
        id: 2164261373,
        label: 'Ventana > Degradado',
        placement: 'MenuBar',
        name: 'Degradado',
    },
    {
        id: 2164261374,
        label: 'Ventana > Trazo',
        placement: 'MenuBar',
        name: 'Trazo',
    },
    {
        id: 2164261375,
        label: 'Ver > Ocultar Anotador de degradado',
        placement: 'MenuBar',
        name: 'Ocultar Anotador de degradado',
    },
    {
        id: 2164261376,
        label: 'Objeto > Trazado > Invertir dirección de trazado',
        placement: 'MenuBar',
        name: 'Invertir dirección de trazado',
    },
    {
        id: 2164261377,
        label: 'Ventana > Transparencia',
        placement: 'MenuBar',
        name: 'Transparencia',
    },
    {
        id: 2164261378,
        label: 'Ver > Mostrar cuadrícula de transparencia',
        placement: 'MenuBar',
        name: 'Mostrar cuadrícula de transparencia',
    },
    {
        id: 2164261379,
        label: 'Ventana > Muestras',
        placement: 'MenuBar',
        name: 'Muestras',
    },
    {
        id: 2164261382,
        label: 'Ventana > Opciones de motivo',
        placement: 'MenuBar',
        name: 'Opciones de motivo',
    },
    {
        id: 2164261383,
        label: 'Ventana > Generar motivos (Beta)',
        placement: 'MenuBar',
        name: 'Generar motivos (Beta)',
    },
    {
        id: 2164261385,
        label: 'Objeto > Motivo > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 2164261387,
        label: 'Objeto > Motivo > Editar motivo',
        placement: 'MenuBar',
        name: 'Editar motivo',
    },
    {
        id: 2164261388,
        label: 'Objeto > Motivo > Color de borde de motivo...',
        placement: 'MenuBar',
        name: 'Color de borde de motivo...',
    },
    {
        id: 2164261390,
        label: 'Objeto > Motivo > Generar motivos (Beta)',
        placement: 'MenuBar',
        name: 'Generar motivos (Beta)',
    },
    {
        id: 2164261391,
        label: 'Ventana > Bibliotecas de muestras > Celebración',
        placement: 'MenuBar',
        name: 'Celebración',
    },
    {
        id: 2164261393,
        label: 'Ventana > Bibliotecas de muestras > Científico > Análogo',
        placement: 'MenuBar',
        name: 'Análogo',
    },
    {
        id: 2164261394,
        label: 'Ventana > Bibliotecas de muestras > Científico > Complementario dividido',
        placement: 'MenuBar',
        name: 'Complementario dividido',
    },
    {
        id: 2164261395,
        label: 'Ventana > Bibliotecas de muestras > Científico > Complementario',
        placement: 'MenuBar',
        name: 'Complementario',
    },
    {
        id: 2164261396,
        label: 'Ventana > Bibliotecas de muestras > Científico > Tétrada',
        placement: 'MenuBar',
        name: 'Tétrada',
    },
    {
        id: 2164261397,
        label: 'Ventana > Bibliotecas de muestras > Científico > Tríada',
        placement: 'MenuBar',
        name: 'Tríada',
    },
    {
        id: 2164261399,
        label: 'Ventana > Bibliotecas de muestras > Comidas > Bebidas',
        placement: 'MenuBar',
        name: 'Bebidas',
    },
    {
        id: 2164261400,
        label: 'Ventana > Bibliotecas de muestras > Comidas > Caramelos',
        placement: 'MenuBar',
        name: 'Caramelos',
    },
    {
        id: 2164261401,
        label: 'Ventana > Bibliotecas de muestras > Comidas > Fruta',
        placement: 'MenuBar',
        name: 'Fruta',
    },
    {
        id: 2164261402,
        label: 'Ventana > Bibliotecas de muestras > Comidas > Helado',
        placement: 'MenuBar',
        name: 'Helado',
    },
    {
        id: 2164261403,
        label: 'Ventana > Bibliotecas de muestras > Comidas > Verduras',
        placement: 'MenuBar',
        name: 'Verduras',
    },
    {
        id: 2164261404,
        label: 'Ventana > Bibliotecas de muestras > Corporativo',
        placement: 'MenuBar',
        name: 'Corporativo',
    },
    {
        id: 2164261405,
        label: 'Ventana > Bibliotecas de muestras > Cosas para niños',
        placement: 'MenuBar',
        name: 'Cosas para niños',
    },
    {
        id: 2164261407,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Agua',
        placement: 'MenuBar',
        name: 'Agua',
    },
    {
        id: 2164261408,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Armonías de color',
        placement: 'MenuBar',
        name: 'Armonías de color',
    },
    {
        id: 2164261409,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Cielo',
        placement: 'MenuBar',
        name: 'Cielo',
    },
    {
        id: 2164261410,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Combinaciones de color',
        placement: 'MenuBar',
        name: 'Combinaciones de color',
    },
    {
        id: 2164261411,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Espectros',
        placement: 'MenuBar',
        name: 'Espectros',
    },
    {
        id: 2164261412,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Estaciones',
        placement: 'MenuBar',
        name: 'Estaciones',
    },
    {
        id: 2164261413,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Frutas y verduras',
        placement: 'MenuBar',
        name: 'Frutas y verduras',
    },
    {
        id: 2164261414,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Gemas y joyas',
        placement: 'MenuBar',
        name: 'Gemas y joyas',
    },
    {
        id: 2164261415,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Luces',
        placement: 'MenuBar',
        name: 'Luces',
    },
    {
        id: 2164261416,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Madera',
        placement: 'MenuBar',
        name: 'Madera',
    },
    {
        id: 2164261417,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Matices y gradaciones',
        placement: 'MenuBar',
        name: 'Matices y gradaciones',
    },
    {
        id: 2164261418,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Metales',
        placement: 'MenuBar',
        name: 'Metales',
    },
    {
        id: 2164261419,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Neutros',
        placement: 'MenuBar',
        name: 'Neutros',
    },
    {
        id: 2164261420,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Pasteles',
        placement: 'MenuBar',
        name: 'Pasteles',
    },
    {
        id: 2164261421,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Piedra y ladrillo',
        placement: 'MenuBar',
        name: 'Piedra y ladrillo',
    },
    {
        id: 2164261422,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Plantas decorativas',
        placement: 'MenuBar',
        name: 'Plantas decorativas',
    },
    {
        id: 2164261423,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Radial simple',
        placement: 'MenuBar',
        name: 'Radial simple',
    },
    {
        id: 2164261424,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Suavizados',
        placement: 'MenuBar',
        name: 'Suavizados',
    },
    {
        id: 2164261425,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Tonos de piel',
        placement: 'MenuBar',
        name: 'Tonos de piel',
    },
    {
        id: 2164261426,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Tonosterrosos',
        placement: 'MenuBar',
        name: 'Tonosterrosos',
    },
    {
        id: 2164261427,
        label: 'Ventana > Bibliotecas de muestras > Degradados > Viñetas',
        placement: 'MenuBar',
        name: 'Viñetas',
    },
    {
        id: 2164261429,
        label: 'Ventana > Bibliotecas de muestras > Historia del arte > Antiguo',
        placement: 'MenuBar',
        name: 'Antiguo',
    },
    {
        id: 2164261430,
        label: 'Ventana > Bibliotecas de muestras > Historia del arte > Arte ruso de carteles',
        placement: 'MenuBar',
        name: 'Arte ruso de carteles',
    },
    {
        id: 2164261431,
        label: 'Ventana > Bibliotecas de muestras > Historia del arte > Barroco',
        placement: 'MenuBar',
        name: 'Barroco',
    },
    {
        id: 2164261432,
        label: 'Ventana > Bibliotecas de muestras > Historia del arte > Impresionista',
        placement: 'MenuBar',
        name: 'Impresionista',
    },
    {
        id: 2164261433,
        label: 'Ventana > Bibliotecas de muestras > Historia del arte > Medieval',
        placement: 'MenuBar',
        name: 'Medieval',
    },
    {
        id: 2164261434,
        label: 'Ventana > Bibliotecas de muestras > Historia del arte > Pop Art',
        placement: 'MenuBar',
        name: 'Pop Art',
    },
    {
        id: 2164261435,
        label: 'Ventana > Bibliotecas de muestras > Historia del arte > Prehistórico',
        placement: 'MenuBar',
        name: 'Prehistórico',
    },
    {
        id: 2164261436,
        label: 'Ventana > Bibliotecas de muestras > Historia del arte > Renacentista',
        placement: 'MenuBar',
        name: 'Renacentista',
    },
    {
        id: 2164261438,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > ANPA Color',
        placement: 'MenuBar',
        name: 'ANPA Color',
    },
    {
        id: 2164261439,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > DIC Color Guide',
        placement: 'MenuBar',
        name: 'DIC Color Guide',
    },
    {
        id: 2164261440,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > FOCOLTONE',
        placement: 'MenuBar',
        name: 'FOCOLTONE',
    },
    {
        id: 2164261441,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > HKS E Process',
        placement: 'MenuBar',
        name: 'HKS E Process',
    },
    {
        id: 2164261442,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > HKS E',
        placement: 'MenuBar',
        name: 'HKS E',
    },
    {
        id: 2164261443,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > HKS K Process',
        placement: 'MenuBar',
        name: 'HKS K Process',
    },
    {
        id: 2164261444,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > HKS K',
        placement: 'MenuBar',
        name: 'HKS K',
    },
    {
        id: 2164261445,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > HKS N Process',
        placement: 'MenuBar',
        name: 'HKS N Process',
    },
    {
        id: 2164261446,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > HKS N',
        placement: 'MenuBar',
        name: 'HKS N',
    },
    {
        id: 2164261447,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > HKS Z Process',
        placement: 'MenuBar',
        name: 'HKS Z Process',
    },
    {
        id: 2164261448,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > HKS Z',
        placement: 'MenuBar',
        name: 'HKS Z',
    },
    {
        id: 2164261449,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > TOYO 94 COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO 94 COLOR FINDER',
    },
    {
        id: 2164261450,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > TOYO COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO COLOR FINDER',
    },
    {
        id: 2164261451,
        label: 'Ventana > Bibliotecas de muestras > Libros de color > TRUMATCH',
        placement: 'MenuBar',
        name: 'TRUMATCH',
    },
    {
        id: 2164261452,
        label: 'Ventana > Bibliotecas de muestras > Metal',
        placement: 'MenuBar',
        name: 'Metal',
    },
    {
        id: 2164261455,
        label: 'Ventana > Bibliotecas de muestras > Motivos > Decorativo > Legado decorativo',
        placement: 'MenuBar',
        name: 'Legado decorativo',
    },
    {
        id: 2164261456,
        label: 'Ventana > Bibliotecas de muestras > Motivos > Decorativo > Motivos Vonster',
        placement: 'MenuBar',
        name: 'Motivos Vonster',
    },
    {
        id: 2164261458,
        label: 'Ventana > Bibliotecas de muestras > Motivos > Gráficos básicos > Gráficos básicos_Líneas',
        placement: 'MenuBar',
        name: 'Gráficos básicos_Líneas',
    },
    {
        id: 2164261459,
        label: 'Ventana > Bibliotecas de muestras > Motivos > Gráficos básicos > Gráficos básicos_Motivo2',
        placement: 'MenuBar',
        name: 'Gráficos básicos_Motivo2',
    },
    {
        id: 2164261460,
        label: 'Ventana > Bibliotecas de muestras > Motivos > Gráficos básicos > Gráficos básicos_Texturas',
        placement: 'MenuBar',
        name: 'Gráficos básicos_Texturas',
    },
    {
        id: 2164261462,
        label: 'Ventana > Bibliotecas de muestras > Motivos > Naturaleza > Naturaleza_Pieles de animales',
        placement: 'MenuBar',
        name: 'Naturaleza_Pieles de animales',
    },
    {
        id: 2164261463,
        label: 'Ventana > Bibliotecas de muestras > Motivos > Naturaleza > Naturaleza_Plantas decorativas',
        placement: 'MenuBar',
        name: 'Naturaleza_Plantas decorativas',
    },
    {
        id: 2164261465,
        label: 'Ventana > Bibliotecas de muestras > Muestras por defecto > Dispositivos',
        placement: 'MenuBar',
        name: 'Dispositivos',
    },
    {
        id: 2164261466,
        label: 'Ventana > Bibliotecas de muestras > Muestras por defecto > Imprimir',
        placement: 'MenuBar',
        name: 'Imprimir',
    },
    {
        id: 2164261467,
        label: 'Ventana > Bibliotecas de muestras > Muestras por defecto > RGB básico',
        placement: 'MenuBar',
        name: 'RGB básico',
    },
    {
        id: 2164261468,
        label: 'Ventana > Bibliotecas de muestras > Muestras por defecto > Vídeo y película',
        placement: 'MenuBar',
        name: 'Vídeo y película',
    },
    {
        id: 2164261469,
        label: 'Ventana > Bibliotecas de muestras > Muestras por defecto > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261471,
        label: 'Ventana > Bibliotecas de muestras > Naturaleza > Estaciones',
        placement: 'MenuBar',
        name: 'Estaciones',
    },
    {
        id: 2164261472,
        label: 'Ventana > Bibliotecas de muestras > Naturaleza > Flores',
        placement: 'MenuBar',
        name: 'Flores',
    },
    {
        id: 2164261473,
        label: 'Ventana > Bibliotecas de muestras > Naturaleza > Paisaje',
        placement: 'MenuBar',
        name: 'Paisaje',
    },
    {
        id: 2164261474,
        label: 'Ventana > Bibliotecas de muestras > Naturaleza > Piedra y ladrillo',
        placement: 'MenuBar',
        name: 'Piedra y ladrillo',
    },
    {
        id: 2164261475,
        label: 'Ventana > Bibliotecas de muestras > Naturaleza > Plantas decorativas',
        placement: 'MenuBar',
        name: 'Plantas decorativas',
    },
    {
        id: 2164261476,
        label: 'Ventana > Bibliotecas de muestras > Naturaleza > Playa',
        placement: 'MenuBar',
        name: 'Playa',
    },
    {
        id: 2164261477,
        label: 'Ventana > Bibliotecas de muestras > Neutro',
        placement: 'MenuBar',
        name: 'Neutro',
    },
    {
        id: 2164261479,
        label: 'Ventana > Bibliotecas de muestras > Propiedades de color > Brillante',
        placement: 'MenuBar',
        name: 'Brillante',
    },
    {
        id: 2164261480,
        label: 'Ventana > Bibliotecas de muestras > Propiedades de color > Cálido',
        placement: 'MenuBar',
        name: 'Cálido',
    },
    {
        id: 2164261481,
        label: 'Ventana > Bibliotecas de muestras > Propiedades de color > Claro',
        placement: 'MenuBar',
        name: 'Claro',
    },
    {
        id: 2164261482,
        label: 'Ventana > Bibliotecas de muestras > Propiedades de color > Desaturado',
        placement: 'MenuBar',
        name: 'Desaturado',
    },
    {
        id: 2164261483,
        label: 'Ventana > Bibliotecas de muestras > Propiedades de color > Frío',
        placement: 'MenuBar',
        name: 'Frío',
    },
    {
        id: 2164261484,
        label: 'Ventana > Bibliotecas de muestras > Propiedades de color > Oscuro',
        placement: 'MenuBar',
        name: 'Oscuro',
    },
    {
        id: 2164261485,
        label: 'Ventana > Bibliotecas de muestras > Propiedades de color > Saturado',
        placement: 'MenuBar',
        name: 'Saturado',
    },
    {
        id: 2164261486,
        label: 'Ventana > Bibliotecas de muestras > Propiedades de color > Suave',
        placement: 'MenuBar',
        name: 'Suave',
    },
    {
        id: 2164261487,
        label: 'Ventana > Bibliotecas de muestras > Sistema (Macintosh)',
        placement: 'MenuBar',
        name: 'Sistema (Macintosh)',
    },
    {
        id: 2164261488,
        label: 'Ventana > Bibliotecas de muestras > Sistema (Windows)',
        placement: 'MenuBar',
        name: 'Sistema (Windows)',
    },
    {
        id: 2164261489,
        label: 'Ventana > Bibliotecas de muestras > Tejidos',
        placement: 'MenuBar',
        name: 'Tejidos',
    },
    {
        id: 2164261490,
        label: 'Ventana > Bibliotecas de muestras > Tonos de piel',
        placement: 'MenuBar',
        name: 'Tonos de piel',
    },
    {
        id: 2164261491,
        label: 'Ventana > Bibliotecas de muestras > Tonos terrosos',
        placement: 'MenuBar',
        name: 'Tonos terrosos',
    },
    {
        id: 2164261492,
        label: 'Ventana > Bibliotecas de muestras > VisiBone2',
        placement: 'MenuBar',
        name: 'VisiBone2',
    },
    {
        id: 2164261493,
        label: 'Ventana > Bibliotecas de muestras > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261496,
        label: 'Ventana > Bibliotecas de muestras > Otra biblioteca...',
        placement: 'MenuBar',
        name: 'Otra biblioteca...',
    },
    {
        id: 2164261497,
        label: 'Ventana > Guía de color',
        placement: 'MenuBar',
        name: 'Guía de color',
    },
    {
        id: 2164261498,
        label: 'Edición > Editar colores > Volver a colorear ilustración...',
        placement: 'MenuBar',
        name: 'Volver a colorear ilustración...',
    },
    {
        id: 2164261501,
        label: 'Edición > Editar colores > Generación de colores de reemplazo',
        placement: 'MenuBar',
        name: 'Generación de colores de reemplazo',
    },
    {
        id: 2164261503,
        label: 'Edición > Editar colores > Volver a colorear con ajuste preestablecido > Biblioteca de colores...',
        placement: 'MenuBar',
        name: 'Biblioteca de colores...',
    },
    {
        id: 2164261504,
        label: 'Edición > Editar colores > Volver a colorear con ajuste preestablecido > Color individual',
        placement: 'MenuBar',
        name: 'Color individual',
    },
    {
        id: 2164261505,
        label: 'Edición > Editar colores > Volver a colorear con ajuste preestablecido > Dos colores',
        placement: 'MenuBar',
        name: 'Dos colores',
    },
    {
        id: 2164261506,
        label: 'Edición > Editar colores > Volver a colorear con ajuste preestablecido > Tres colores',
        placement: 'MenuBar',
        name: 'Tres colores',
    },
    {
        id: 2164261507,
        label: 'Edición > Editar colores > Volver a colorear con ajuste preestablecido > Armonía de color',
        placement: 'MenuBar',
        name: 'Armonía de color',
    },
    {
        id: 2164261508,
        label: 'Ventana > Control',
        placement: 'MenuBar',
        name: 'Control',
    },
    {
        id: 2164261509,
        label: 'Ventana > Barra de tareas contextuales',
        placement: 'MenuBar',
        name: 'Barra de tareas contextuales',
    },
    {
        id: 2164261511,
        label: 'Objeto > Entrelazado > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 2164261512,
        label: 'Objeto > Entrelazado > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 2164261513,
        label: 'Objeto > Entrelazado > Edición',
        placement: 'MenuBar',
        name: 'Edición',
    },
    {
        id: 2164261514,
        label: 'Ventana > Alinear',
        placement: 'MenuBar',
        name: 'Alinear',
    },
    {
        id: 2164261516,
        label: 'Objeto > Alinear > Alinear horizontalmente a la izquierda',
        placement: 'MenuBar',
        name: 'Alinear horizontalmente a la izquierda',
    },
    {
        id: 2164261517,
        label: 'Objeto > Alinear > Alinear horizontalmente al centro',
        placement: 'MenuBar',
        name: 'Alinear horizontalmente al centro',
    },
    {
        id: 2164261518,
        label: 'Objeto > Alinear > Alinear horizontalmente a la derecha',
        placement: 'MenuBar',
        name: 'Alinear horizontalmente a la derecha',
    },
    {
        id: 2164261519,
        label: 'Objeto > Alinear > Alinear verticalmente arriba',
        placement: 'MenuBar',
        name: 'Alinear verticalmente arriba',
    },
    {
        id: 2164261520,
        label: 'Objeto > Alinear > Alinear verticalmente al centro',
        placement: 'MenuBar',
        name: 'Alinear verticalmente al centro',
    },
    {
        id: 2164261521,
        label: 'Objeto > Alinear > Alinear verticalmente abajo',
        placement: 'MenuBar',
        name: 'Alinear verticalmente abajo',
    },
    {
        id: 2164261523,
        label: 'Objeto > Distribuir > Distribuir hacia arriba',
        placement: 'MenuBar',
        name: 'Distribuir hacia arriba',
    },
    {
        id: 2164261524,
        label: 'Objeto > Distribuir > Distribuir al centro verticalmente',
        placement: 'MenuBar',
        name: 'Distribuir al centro verticalmente',
    },
    {
        id: 2164261525,
        label: 'Objeto > Distribuir > Distribuir hacia abajo',
        placement: 'MenuBar',
        name: 'Distribuir hacia abajo',
    },
    {
        id: 2164261526,
        label: 'Objeto > Distribuir > Distribuir a la izquierda',
        placement: 'MenuBar',
        name: 'Distribuir a la izquierda',
    },
    {
        id: 2164261527,
        label: 'Objeto > Distribuir > Distribuir al centro',
        placement: 'MenuBar',
        name: 'Distribuir al centro',
    },
    {
        id: 2164261528,
        label: 'Objeto > Distribuir > Distribuir a la derecha',
        placement: 'MenuBar',
        name: 'Distribuir a la derecha',
    },
    {
        id: 2164261529,
        label: 'Ventana > Transformar',
        placement: 'MenuBar',
        name: 'Transformar',
    },
    {
        id: 2164261530,
        label: 'Ver > Ocultar widget de vértices',
        placement: 'MenuBar',
        name: 'Ocultar widget de vértices',
    },
    {
        id: 2164261532,
        label: 'Objeto > Repetir > Radial',
        placement: 'MenuBar',
        name: 'Radial',
    },
    {
        id: 2164261533,
        label: 'Objeto > Repetir > Cuadrícula',
        placement: 'MenuBar',
        name: 'Cuadrícula',
    },
    {
        id: 2164261534,
        label: 'Objeto > Repetir > Reflejo',
        placement: 'MenuBar',
        name: 'Reflejo',
    },
    {
        id: 2164261536,
        label: 'Objeto > Repetir > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 2164261537,
        label: 'Objeto > Repetir > Opciones...',
        placement: 'MenuBar',
        name: 'Opciones...',
    },
    {
        id: 2164261539,
        label: 'Objeto > Objetos en trazado > Adjuntar...',
        placement: 'MenuBar',
        name: 'Adjuntar...',
    },
    {
        id: 2164261540,
        label: 'Objeto > Objetos en trazado > Opciones...',
        placement: 'MenuBar',
        name: 'Opciones...',
    },
    {
        id: 2164261541,
        label: 'Objeto > Objetos en trazado > Expandir',
        placement: 'MenuBar',
        name: 'Expandir',
    },
    {
        id: 2164261542,
        label: 'Efecto > Trazado > Contornear trazado',
        placement: 'MenuBar',
        name: 'Contornear trazado',
    },
    {
        id: 2164261543,
        label: 'Efecto > Trazado > Desplazamiento...',
        placement: 'MenuBar',
        name: 'Desplazamiento...',
    },
    {
        id: 2164261544,
        label: 'Objeto > Trazado > Contornear trazado',
        placement: 'MenuBar',
        name: 'Contornear trazado',
    },
    {
        id: 2164261545,
        label: 'Objeto > Trazado > Desplazamiento...',
        placement: 'MenuBar',
        name: 'Desplazamiento...',
    },
    {
        id: 2164261547,
        label: 'Ventana > Barras de herramientas > Básica',
        placement: 'MenuBar',
        name: 'Básica',
    },
    {
        id: 2164261548,
        label: 'Ventana > Barras de herramientas > Avanzado',
        placement: 'MenuBar',
        name: 'Avanzado',
    },
    {
        id: 2164261549,
        label: 'Ventana > Barras de herramientas > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261551,
        label: 'Ventana > Barras de herramientas > Nueva barra de herramientas...',
        placement: 'MenuBar',
        name: 'Nueva barra de herramientas...',
    },
    {
        id: 2164261552,
        label: 'Ventana > Barras de herramientas > Administrar barras de herramientas...',
        placement: 'MenuBar',
        name: 'Administrar barras de herramientas...',
    },
    {
        id: 2164261553,
        label: 'Ventana > Atributos',
        placement: 'MenuBar',
        name: 'Atributos',
    },
    {
        id: 2164261554,
        label: 'Texto > Más información de Adobe Fonts...',
        placement: 'MenuBar',
        name: 'Más información de Adobe Fonts...',
    },
    {
        id: 2164261555,
        label: 'Texto > Resolver fuentes no disponibles...',
        placement: 'MenuBar',
        name: 'Resolver fuentes no disponibles...',
    },
    {
        id: 2164261556,
        label: 'Ayuda > Ayuda de la comunidad',
        placement: 'MenuBar',
        name: 'Ayuda de la comunidad',
    },
    {
        id: 2164261557,
        label: 'Ayuda > Enviar solicitud de función/error...',
        placement: 'MenuBar',
        name: 'Enviar solicitud de función/error...',
    },
    {
        id: 2164261559,
        label: 'Objeto > Generar píxeles perfectos',
        placement: 'MenuBar',
        name: 'Generar píxeles perfectos',
    },
    {
        id: 2164261560,
        label: 'Ventana > Texto > Visualizador de Reflow',
        placement: 'MenuBar',
        name: 'Visualizador de Reflow',
    },
    {
        id: 2164261561,
        label: 'Ayuda > Guía del usuario de IA generativa',
        placement: 'MenuBar',
        name: 'Guía del usuario de IA generativa',
    },
    {
        id: 2164261563,
        label: 'Edición > Ajustes preestablecidos de impresión...',
        placement: 'MenuBar',
        name: 'Ajustes preestablecidos de impresión...',
    },
    {
        id: 2164261565,
        label: 'Archivo > Imprimir...',
        placement: 'MenuBar',
        name: 'Imprimir...',
    },
    {
        id: 2164261566,
        label: 'Edición > Ajustes preestablecidos del acoplador de transparencias…',
        placement: 'MenuBar',
        name: 'Ajustes preestablecidos del acoplador de transparencias…',
    },
    {
        id: 2164261567,
        label: 'Objeto > Acoplar transparencia...',
        placement: 'MenuBar',
        name: 'Acoplar transparencia...',
    },
    {
        id: 2164261569,
        label: 'Objeto > Forma > Convertir en forma',
        placement: 'MenuBar',
        name: 'Convertir en forma',
    },
    {
        id: 2164261570,
        label: 'Objeto > Forma > Expandir forma',
        placement: 'MenuBar',
        name: 'Expandir forma',
    },
    {
        id: 2164261571,
        label: 'Ventana > Maqueta',
        placement: 'MenuBar',
        name: 'Maqueta',
    },
    {
        id: 2164261572,
        label: 'Ventana > Variaciones generadas',
        placement: 'MenuBar',
        name: 'Variaciones generadas',
    },
    {
        id: 2164261573,
        label: 'Objeto > Generar vectores (Beta)...',
        placement: 'MenuBar',
        name: 'Generar vectores (Beta)...',
    },
    {
        id: 2164261574,
        label: 'Archivo > Generar vectores (Beta)...',
        placement: 'MenuBar',
        name: 'Generar vectores (Beta)...',
    },
    {
        id: 2164261575,
        label: 'Objeto > Relleno generativo de forma (Beta)...',
        placement: 'MenuBar',
        name: 'Relleno generativo de forma (Beta)...',
    },
    {
        id: 2164261576,
        label: 'Ventana > 3D y materiales',
        placement: 'MenuBar',
        name: '3D y materiales',
    },
    {
        id: 2164261578,
        label: 'Objeto > Perspectiva > Adjuntar a plano activo',
        placement: 'MenuBar',
        name: 'Adjuntar a plano activo',
    },
    {
        id: 2164261579,
        label: 'Objeto > Perspectiva > Dejar con perspectiva',
        placement: 'MenuBar',
        name: 'Dejar con perspectiva',
    },
    {
        id: 2164261580,
        label: 'Objeto > Perspectiva > Mover plano para coincidir con objeto',
        placement: 'MenuBar',
        name: 'Mover plano para coincidir con objeto',
    },
    {
        id: 2164261581,
        label: 'Objeto > Perspectiva > Editar texto',
        placement: 'MenuBar',
        name: 'Editar texto',
    },
    {
        id: 2164261582,
        label: 'Edición > Ajustes preestablecidos de cuadrícula de perspectiva...',
        placement: 'MenuBar',
        name: 'Ajustes preestablecidos de cuadrícula de perspectiva...',
    },
    {
        id: 2164261585,
        label: 'Ver > Cuadrícula de perspectiva > Mostrar cuadrícula',
        placement: 'MenuBar',
        name: 'Mostrar cuadrícula',
    },
    {
        id: 2164261586,
        label: 'Ver > Cuadrícula de perspectiva > Mostrar reglas',
        placement: 'MenuBar',
        name: 'Mostrar reglas',
    },
    {
        id: 2164261587,
        label: 'Ver > Cuadrícula de perspectiva > Ajustar a cuadrícula',
        placement: 'MenuBar',
        name: 'Ajustar a cuadrícula',
    },
    {
        id: 2164261588,
        label: 'Ver > Cuadrícula de perspectiva > Bloquear cuadrícula',
        placement: 'MenuBar',
        name: 'Bloquear cuadrícula',
    },
    {
        id: 2164261589,
        label: 'Ver > Cuadrícula de perspectiva > Bloquear punto de estación',
        placement: 'MenuBar',
        name: 'Bloquear punto de estación',
    },
    {
        id: 2164261591,
        label: 'Ver > Cuadrícula de perspectiva > Definir cuadrícula...',
        placement: 'MenuBar',
        name: 'Definir cuadrícula...',
    },
    {
        id: 2164261597,
        label: 'Ver > Cuadrícula de perspectiva > Guardar cuadrícula como ajuste preestablecido...',
        placement: 'MenuBar',
        name: 'Guardar cuadrícula como ajuste preestablecido...',
    },
    {
        id: 2164261598,
        label: 'Ventana > Calco de imagen',
        placement: 'MenuBar',
        name: 'Calco de imagen',
    },
    {
        id: 2164261600,
        label: 'Objeto > Calco de imagen > Crear',
        placement: 'MenuBar',
        name: 'Crear',
    },
    {
        id: 2164261601,
        label: 'Objeto > Calco de imagen > Crear y expandir',
        placement: 'MenuBar',
        name: 'Crear y expandir',
    },
    {
        id: 2164261602,
        label: 'Objeto > Calco de imagen > Soltar',
        placement: 'MenuBar',
        name: 'Soltar',
    },
    {
        id: 2164261604,
        label: 'Objeto > Calco de imagen > Expandir',
        placement: 'MenuBar',
        name: 'Expandir',
    },
    {
        id: 2164261605,
        label: 'Efecto > Desenfocar > Desenfoque gaussiano...',
        placement: 'MenuBar',
        name: 'Desenfoque gaussiano...',
    },
    {
        id: 2164261606,
        label: 'Edición > Ajustes preestablecidos de Adobe PDF...',
        placement: 'MenuBar',
        name: 'Ajustes preestablecidos de Adobe PDF...',
    },
    {
        id: 2164261607,
        label: 'Ventana > Exportación de recursos',
        placement: 'MenuBar',
        name: 'Exportación de recursos',
    },
    {
        id: 2164261608,
        label: 'Archivo > Invitar a editar...',
        placement: 'MenuBar',
        name: 'Invitar a editar...',
    },
    {
        id: 2164261609,
        label: 'Archivo > Compartir para revisión...',
        placement: 'MenuBar',
        name: 'Compartir para revisión...',
    },
    {
        id: 2164261610,
        label: 'Ver > Cuadrícula de perspectiva > Perspectiva de un punto > [Vista normal 1P]',
        placement: 'MenuBar',
        name: '[Vista normal 1P]',
    },
    {
        id: 2164261611,
        label: 'Ver > Cuadrícula de perspectiva > Perspectiva de dos puntos > [Vista normal 2P]',
        placement: 'MenuBar',
        name: '[Vista normal 2P]',
    },
    {
        id: 2164261612,
        label: 'Ver > Cuadrícula de perspectiva > Perspectiva de tres puntos > [Vista normal 3P]',
        placement: 'MenuBar',
        name: '[Vista normal 3P]',
    },
    {
        id: 2164261615,
        label: 'Ventana > Extensiones > Bibliotecas',
        placement: 'MenuBar',
        name: 'Bibliotecas',
    },
    {
        id: 2164261616,
        label: 'Ventana > Historial de versiones',
        placement: 'MenuBar',
        name: 'Historial de versiones',
    },
    {
        id: 2164261617,
        label: 'Archivo > Historial de versiones',
        placement: 'MenuBar',
        name: 'Historial de versiones',
    },
    {
        id: 2164261618,
        label: 'Ventana > Comentarios',
        placement: 'MenuBar',
        name: 'Comentarios',
    },
    {
        id: 'Adobe Scroll Tool',
        label: 'Herramienta Mano',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pen Tool',
        label: 'Herramienta Pluma',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scale Tool',
        label: 'Herramienta Escala',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Tool',
        label: 'Herramienta Rotar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reflect Tool',
        label: 'Herramienta Reflejo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shear Tool',
        label: 'Herramienta Distorsión',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scissors Tool',
        label: 'Herramienta Tijeras',
        placement: 'Tool',
    },
    {
        id: 'Adobe Measure Tool',
        label: 'Herramienta Medición',
        placement: 'Tool',
    },
    {
        id: 'Adobe Page Tool',
        label: 'Herramienta Segmentación de impresión',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Object Select Tool',
        label: 'Herramienta Selección de grupos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Select Tool',
        label: 'Herramienta Selección directa',
        placement: 'Tool',
    },
    {
        id: 'Adobe Select Tool',
        label: 'Herramienta Selección',
        placement: 'Tool',
    },
    {
        id: 'Adobe Zoom Tool',
        label: 'Herramienta Zoom',
        placement: 'Tool',
    },
    {
        id: 'Adobe Add Anchor Point Tool',
        label: 'Herramienta Añadir punto de ancla',
        placement: 'Tool',
    },
    {
        id: 'Adobe Delete Anchor Point Tool',
        label: 'Herramienta Eliminar punto de ancla',
        placement: 'Tool',
    },
    {
        id: 'Adobe Anchor Point Tool',
        label: 'Herramienta Punto de ancla',
        placement: 'Tool',
    },
    {
        id: 'Adobe Column Graph Tool',
        label: 'Herramienta Gráfico de columnas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Column Graph Tool',
        label: 'Herramienta Gráfico de columnas apiladas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Graph Tool',
        label: 'Herramienta Gráfico lineal',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pie Graph Tool',
        label: 'Herramienta Gráfico circular',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Graph Tool',
        label: 'Herramienta Gráfico de áreas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scatter Graph Tool',
        label: 'Herramienta Gráfico de dispersión',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bar Graph Tool',
        label: 'Herramienta Gráfico de barras',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Bar Graph Tool',
        label: 'Herramienta Gráfico de barras apiladas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Radar Graph Tool',
        label: 'Herramienta Gráfico de radar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Mesh Editing Tool',
        label: 'Herramienta Malla',
        placement: 'Tool',
    },
    {
        id: 'Adobe Type Tool',
        label: 'Herramienta Texto',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Type Tool',
        label: 'Herramienta Texto de área',
        placement: 'Tool',
    },
    {
        id: 'Adobe Path Type Tool',
        label: 'Herramienta Texto en trazado',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Type Tool',
        label: 'Herramienta Texto vertical',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Area Type Tool',
        label: 'Herramienta Texto de área vertical',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Path Type Tool',
        label: 'Herramienta Texto vertical en trazado',
        placement: 'Tool',
    },
    {
        id: 'Adobe Touch Type Tool',
        label: 'Herramienta Retocar texto',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Builder Tool',
        label: 'Herramienta Creador de formas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Paintbucket Tool',
        label: 'Bote de pintura interactiva',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Face Select Tool',
        label: 'Herramienta Selección de pintura interactiva',
        placement: 'Tool',
    },
    {
        id: 'Perspective Grid Tool',
        label: 'Herramienta Cuadrícula de perspectiva',
        placement: 'Tool',
    },
    {
        id: 'Perspective Selection Tool',
        label: 'Herramienta Selección de perspectiva',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blend Tool',
        label: 'Herramienta Fusión',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Tool',
        label: 'Herramienta Sector',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Select Tool',
        label: 'Herramienta Seleccionar sector',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Lasso Tool',
        label: 'Herramienta Lazo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Crop Tool',
        label: 'Herramienta Mesa de trabajo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Curvature Tool',
        label: 'Herramienta Curvatura',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shaper Tool',
        label: 'Herramienta Shaper',
        placement: 'Tool',
    },
    {
        id: 'Adobe Puppet Warp Tool',
        label: 'Herramienta Deformación de posición libre',
        placement: 'Tool',
    },
    {
        id: 'Adobe Magic Wand Tool',
        label: 'Herramienta Varita mágica',
        placement: 'Tool',
    },
    {
        id: 'Adobe Knife Tool',
        label: 'Herramienta Cuchilla',
        placement: 'Tool',
    },
    {
        id: 'Adobe Flare Tool',
        label: 'Herramienta Destello',
        placement: 'Tool',
    },
    {
        id: 'Adobe Free Transform Tool',
        label: 'Herramienta Transformación libre',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Tool',
        label: 'Herramienta Segmento de línea',
        placement: 'Tool',
    },
    {
        id: 'Adobe Arc Tool',
        label: 'Herramienta Arco',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangular Grid Tool',
        label: 'Herramienta Cuadrícula rectangular',
        placement: 'Tool',
    },
    {
        id: 'Adobe Polar Grid Tool',
        label: 'Herramienta Cuadrícula polar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Warp Tool',
        label: 'Herramienta Deformar',
        placement: 'Tool',
    },
    {
        id: 'Adobe New Twirl Tool',
        label: 'Herramienta Molinete',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pucker Tool',
        label: 'Herramienta Fruncir',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bloat Tool',
        label: 'Herramienta Engordar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scallop Tool',
        label: 'Herramienta Festonear',
        placement: 'Tool',
    },
    {
        id: 'Adobe Cyrstallize Tool',
        label: 'Herramienta Cristalizar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Wrinkle Tool',
        label: 'Herramienta Arrugar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Quick Pen Tool',
        label: 'Herramienta Pluma rápida',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Tool',
        label: 'Herramienta Lápiz',
        placement: 'Tool',
    },
    {
        id: 'Adobe Brush Tool',
        label: 'Herramienta Pincel',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blob Brush Tool',
        label: 'Herramienta Pincel de manchas',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Smooth Tool',
        label: 'Herramienta Suavizar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Erase Tool',
        label: 'Herramienta Borrador de trazados',
        placement: 'Tool',
    },
    {
        id: 'Adobe Corner Join Tool',
        label: 'Herramienta Unir',
        placement: 'Tool',
    },
    {
        id: 'Adobe Ellipse Shape Tool',
        label: 'Herramienta Elipse',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Regular Polygon Tool',
        label: 'Herramienta Polígono',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Star Tool',
        label: 'Herramienta Estrella',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangle Shape Tool',
        label: 'Herramienta Rectángulo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rounded Rectangle Tool',
        label: 'Herramienta Rectángulo redondeado',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Spiral Tool',
        label: 'Herramienta Espiral',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sprayer Tool',
        label: 'Herramienta Rociar símbolo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Shifter Tool',
        label: 'Herramienta Desplazar símbolo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Scruncher Tool',
        label: 'Herramienta Reunir/Separar símbolos',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sizer Tool',
        label: 'Herramienta Cambiar tamaño de símbolo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Spinner Tool',
        label: 'Herramienta Girar símbolo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Stainer Tool',
        label: 'Herramienta Manchar símbolo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Screener Tool',
        label: 'Herramienta Translucir símbolo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Styler Tool',
        label: 'Herramienta Aplicar estilo a símbolo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Gradient Vector Tool',
        label: 'Herramienta Degradado',
        placement: 'Tool',
    },
    {
        id: 'Adobe Dimension Tool',
        label: 'Herramienta de dimensión',
        placement: 'Tool',
    },
    {
        id: 'Adobe Constraints Tool',
        label: 'Objetos en trazado',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Canvas Tool',
        label: 'Herramienta Rotar vista',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reshape Tool',
        label: 'Herramienta Reformar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Width Tool',
        label: 'Herramienta Anchura',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eraser Tool',
        label: 'Herramienta Borrador',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eyedropper Tool',
        label: 'Herramienta Cuentagotas',
        placement: 'Tool',
    },
    {
        id: '3D and Materials',
        label: '3D y materiales',
        placement: 'Panel',
    },
    {
        id: 'Actions',
        label: 'Acciones',
        placement: 'Panel',
    },
    {
        id: 'AdobeAltGlyphsPanel',
        label: 'Glifos',
        placement: 'Panel',
    },
    {
        id: 'AdobeBrush',
        label: 'Pinceles',
        placement: 'Panel',
    },
    {
        id: 'AdobeCharStyles',
        label: 'Estilos de carácter',
        placement: 'Panel',
    },
    {
        id: 'AdobeColorGuidePanel',
        label: 'Guía de color',
        placement: 'Panel',
    },
    {
        id: 'AdobeFlatteningPreview',
        label: 'Previsualizar acomplamiento',
        placement: 'Panel',
    },
    {
        id: 'AdobeGradientEditor',
        label: 'Degradado',
        placement: 'Panel',
    },
    {
        id: 'AdobeHorizontalTabPanel',
        label: 'Tabulaciones',
        placement: 'Panel',
    },
    {
        id: 'AdobeLayerPalette',
        label: 'Capas',
        placement: 'Panel',
    },
    {
        id: 'AdobeObjectAttributes',
        label: 'Atributos',
        placement: 'Panel',
    },
    {
        id: 'AdobeOpenTypeFont',
        label: 'OpenType',
        placement: 'Panel',
    },
    {
        id: 'AdobeParaStyles',
        label: 'Estilos de párrafo',
        placement: 'Panel',
    },
    {
        id: 'AdobePropertiesPanel',
        label: 'Propiedades',
        placement: 'Panel',
    },
    {
        id: 'AdobeSeparationPreview',
        label: 'Previsualizar separaciones',
        placement: 'Panel',
    },
    {
        id: 'AdobeSwatch_',
        label: 'Muestras',
        placement: 'Panel',
    },
    {
        id: 'AdobeVariablesPanel',
        label: 'Variables',
        placement: 'Panel',
    },
    {
        id: 'AdobeVerticalTabPanel',
        label: 'Tabulaciones',
        placement: 'Panel',
    },
    {
        id: 'Align',
        label: 'Alinear',
        placement: 'Panel',
    },
    {
        id: 'Appearance',
        label: 'Apariencia',
        placement: 'Panel',
    },
    {
        id: 'Artboards',
        label: 'Mesas de trabajo',
        placement: 'Panel',
    },
    {
        id: 'CCX Commenting UXP Webview',
        label: 'Comentarios',
        placement: 'Panel',
    },
    {
        id: 'CSS',
        label: 'Propiedades CSS (obsoleto)',
        placement: 'Panel',
    },
    {
        id: 'CSXSExtension_com.adobe.DesignLibraries.angular_0',
        label: 'Bibliotecas',
        placement: 'Panel',
    },
    {
        id: 'Character',
        label: 'Carácter',
        placement: 'Panel',
    },
    {
        id: 'Color',
        label: 'Color',
        placement: 'Panel',
    },
    {
        id: 'Document Info',
        label: 'Información de documento',
        placement: 'Panel',
    },
    {
        id: 'Export',
        label: 'Exportación de recursos',
        placement: 'Panel',
    },
    {
        id: 'GeneratedVariations',
        label: 'Variaciones generadas',
        placement: 'Panel',
    },
    {
        id: 'History',
        label: 'Historial',
        placement: 'Panel',
    },
    {
        id: 'Info',
        label: 'Información',
        placement: 'Panel',
    },
    {
        id: 'Links',
        label: 'Enlaces',
        placement: 'Panel',
    },
    {
        id: 'Magic Wand',
        label: 'Varita mágica',
        placement: 'Panel',
    },
    {
        id: 'Mockup',
        label: 'Maqueta',
        placement: 'Panel',
    },
    {
        id: 'NamedStyle',
        label: 'Estilos gráficos',
        placement: 'Panel',
    },
    {
        id: 'Navigator',
        label: 'Navegador',
        placement: 'Panel',
    },
    {
        id: 'Paragraph',
        label: 'Párrafo',
        placement: 'Panel',
    },
    {
        id: 'Pathfinder',
        label: 'Buscatrazos',
        placement: 'Panel',
    },
    {
        id: 'PatternOptionsPanel',
        label: ' Opciones de motivo',
        placement: 'Panel',
    },
    {
        id: 'Reflow Viewer',
        label: 'Visualizador de Reflow',
        placement: 'Panel',
    },
    {
        id: 'Retype',
        label: 'Retype',
        placement: 'Panel',
    },
    {
        id: 'SVGInteractivity',
        label: 'Interactividad SVG',
        placement: 'Panel',
    },
    {
        id: 'Stroke',
        label: 'Trazo',
        placement: 'Panel',
    },
    {
        id: 'Symbols',
        label: 'Símbolos',
        placement: 'Panel',
    },
    {
        id: 'Transform',
        label: 'Transformar',
        placement: 'Panel',
    },
    {
        id: 'Transparency',
        label: 'Transparencia',
        placement: 'Panel',
    },
    {
        id: 'Vectorize',
        label: 'Calco de imagen',
        placement: 'Panel',
    },
    {
        id: 'ccx-timeline',
        label: 'Historial de versiones',
        placement: 'Panel',
    },
];
